//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
  private readonly config: IConfig;

  constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    const authorizationHeaderValue = this.config.getAuthorization();

    if(authorizationHeaderValue !== null && authorizationHeaderValue !== undefined){
      // Update headers to add the JWT Token
      options.headers = {
        ...options.headers,
        Authorization: authorizationHeaderValue,
      };
    }

    return Promise.resolve(options);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {

    if (response.status === 401) {
      console.warn(`Unauthorised API call url=${response.url}`);

      // Logout
      this.config.onLogout();
    }

    return processor(response);
  }
}

export class LoanClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param loanId (optional) 
     * @return OK
     */
    getOpenLoanDetails(loanId: string | undefined): Promise<OpenLoanDetailsResponse> {
        let url_ = this.baseUrl + "/credit/open-loan-details?";
        if (loanId === null)
            throw new globalThis.Error("The parameter 'loanId' cannot be null.");
        else if (loanId !== undefined)
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOpenLoanDetails(_response));
        });
    }

    protected processGetOpenLoanDetails(response: Response): Promise<OpenLoanDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpenLoanDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenLoanDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    hasOpenLoanOrApplications(): Promise<HasOpenLoanOrApplicationsResponse> {
        let url_ = this.baseUrl + "/credit/has-open-loan-or-applications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasOpenLoanOrApplications(_response));
        });
    }

    protected processHasOpenLoanOrApplications(response: Response): Promise<HasOpenLoanOrApplicationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HasOpenLoanOrApplicationsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HasOpenLoanOrApplicationsResponse>(null as any);
    }

    /**
     * @return OK
     */
    isExistingCustomer(): Promise<IsExistingCustomerResponse> {
        let url_ = this.baseUrl + "/credit/is-existing-customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsExistingCustomer(_response));
        });
    }

    protected processIsExistingCustomer(response: Response): Promise<IsExistingCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsExistingCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsExistingCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoansSummary(): Promise<GetLoansSummaryResponse> {
        let url_ = this.baseUrl + "/credit/loans-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLoansSummary(_response));
        });
    }

    protected processGetLoansSummary(response: Response): Promise<GetLoansSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoansSummaryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLoansSummaryResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAffordabilityChallenge(loanId: string): Promise<GetAffordabilityChallengeResponseModel> {
        let url_ = this.baseUrl + "/affordability-challenge/get-affordability-challenge?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAffordabilityChallenge(_response));
        });
    }

    protected processGetAffordabilityChallenge(response: Response): Promise<GetAffordabilityChallengeResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAffordabilityChallengeResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAffordabilityChallengeResponseModel>(null as any);
    }

    /**
     * @return OK
     */
    submitAffordabilityChallenge(body: AcceptAffordabilityChallengeRequestModel): Promise<AcceptAffordabilityChallengeResponse> {
        let url_ = this.baseUrl + "/affordability-challenge/accept-affordability-challenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitAffordabilityChallenge(_response));
        });
    }

    protected processSubmitAffordabilityChallenge(response: Response): Promise<AcceptAffordabilityChallengeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptAffordabilityChallengeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptAffordabilityChallengeResponse>(null as any);
    }

    /**
     * @return OK
     */
    saveApplication(body: SaveApplicationRequest): Promise<SaveApplicationResponse> {
        let url_ = this.baseUrl + "/application/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveApplication(_response));
        });
    }

    protected processSaveApplication(response: Response): Promise<SaveApplicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveApplicationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    apply(body: LoanApplicationRequest): Promise<LoanApplicationResponse> {
        let url_ = this.baseUrl + "/application/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApply(_response));
        });
    }

    protected processApply(response: Response): Promise<LoanApplicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoanApplicationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    signApplication(body: SignApplicationRequest): Promise<SignApplicationResponse> {
        let url_ = this.baseUrl + "/application/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSignApplication(_response));
        });
    }

    protected processSignApplication(response: Response): Promise<SignApplicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignApplicationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    canApply(productId: string): Promise<CanApplyResponse> {
        let url_ = this.baseUrl + "/application/can-apply/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanApply(_response));
        });
    }

    protected processCanApply(response: Response): Promise<CanApplyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanApplyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CanApplyResponse>(null as any);
    }

    /**
     * @return OK
     */
    declineLoanAgreement(body: DeclineLoanAgreementRequest): Promise<DeclineLoanAgreementResponse> {
        let url_ = this.baseUrl + "/application/decline-loan-agreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeclineLoanAgreement(_response));
        });
    }

    protected processDeclineLoanAgreement(response: Response): Promise<DeclineLoanAgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeclineLoanAgreementResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeclineLoanAgreementResponse>(null as any);
    }

    /**
     * @return OK
     */
    declineApplication(body: DeclineApplicationRequest): Promise<DeclineApplicationResponse> {
        let url_ = this.baseUrl + "/application/decline-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeclineApplication(_response));
        });
    }

    protected processDeclineApplication(response: Response): Promise<DeclineApplicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeclineApplicationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeclineApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCancelledDeclinedApplications(): Promise<GetCancelledDeclinedApplicationsApiResponse> {
        let url_ = this.baseUrl + "/cancelled-declined-applications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCancelledDeclinedApplications(_response));
        });
    }

    protected processGetCancelledDeclinedApplications(response: Response): Promise<GetCancelledDeclinedApplicationsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCancelledDeclinedApplicationsApiResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCancelledDeclinedApplicationsApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCounteroffer(loanId: string): Promise<CounterOfferResponse> {
        let url_ = this.baseUrl + "/counteroffers/get-counteroffer?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCounteroffer(_response));
        });
    }

    protected processGetCounteroffer(response: Response): Promise<CounterOfferResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CounterOfferResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CounterOfferResponse>(null as any);
    }

    /**
     * @return OK
     */
    acceptCounteroffer(body: AcceptOfferRequest): Promise<AcceptOfferResponse> {
        let url_ = this.baseUrl + "/counteroffers/accept-counteroffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAcceptCounteroffer(_response));
        });
    }

    protected processAcceptCounteroffer(response: Response): Promise<AcceptOfferResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptOfferResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcceptOfferResponse>(null as any);
    }

    /**
     * @return OK
     */
    rejectCounteroffer(body: RejectOfferRequest): Promise<RejectOfferResponse> {
        let url_ = this.baseUrl + "/counteroffers/reject-counteroffer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRejectCounteroffer(_response));
        });
    }

    protected processRejectCounteroffer(response: Response): Promise<RejectOfferResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RejectOfferResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RejectOfferResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDebitOrderSchedule(loanId: string): Promise<GetDebitOrderScheduleResponse> {
        let url_ = this.baseUrl + "/debit-order-schedule?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDebitOrderSchedule(_response));
        });
    }

    protected processGetDebitOrderSchedule(response: Response): Promise<GetDebitOrderScheduleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDebitOrderScheduleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDebitOrderScheduleResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDebtSaleStatus(loanId: string): Promise<DebtSaleStatusResponse> {
        let url_ = this.baseUrl + "/debt-sale-status?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDebtSaleStatus(_response));
        });
    }

    protected processGetDebtSaleStatus(response: Response): Promise<DebtSaleStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtSaleStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtSaleStatusResponse>(null as any);
    }

    /**
     * @param wait (optional) 
     * @return OK
     */
    getDecision(loanId: string, wait: number | undefined): Promise<DecisionResponse> {
        let url_ = this.baseUrl + "/decision/{loanId}?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        if (wait === null)
            throw new globalThis.Error("The parameter 'wait' cannot be null.");
        else if (wait !== undefined)
            url_ += "wait=" + encodeURIComponent("" + wait) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDecision(_response));
        });
    }

    protected processGetDecision(response: Response): Promise<DecisionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DecisionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DecisionResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDeclineReason(loanId: string): Promise<DeclineReasonResponse> {
        let url_ = this.baseUrl + "/decline-reason/{loanId}";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDeclineReason(_response));
        });
    }

    protected processGetDeclineReason(response: Response): Promise<DeclineReasonResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeclineReasonResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeclineReasonResponse>(null as any);
    }

    /**
     * @return OK
     */
    getHealth(): Promise<HealthResponse> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealth(_response));
        });
    }

    protected processGetHealth(response: Response): Promise<HealthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthResponse>(null as any);
    }

    /**
     * @return OK
     */
    completeUpload(body: CompleteUploadRequest): Promise<void> {
        let url_ = this.baseUrl + "/income-verification/complete-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompleteUpload(_response));
        });
    }

    protected processCompleteUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getTruIdRedirectUrl(loanId: string): Promise<string> {
        let url_ = this.baseUrl + "/income-verification/truId/get-redirect-url/{loanId}";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTruIdRedirectUrl(_response));
        });
    }

    protected processGetTruIdRedirectUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    canUploadDocuments(loanId: string): Promise<CanUploadDocumentsResponse> {
        let url_ = this.baseUrl + "/income-verification/can-upload/{loanId}";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCanUploadDocuments(_response));
        });
    }

    protected processCanUploadDocuments(response: Response): Promise<CanUploadDocumentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CanUploadDocumentsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CanUploadDocumentsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoanAgreement(loanId: string): Promise<GetLoanAgreementResponse> {
        let url_ = this.baseUrl + "/document/{loanId}/loan-agreement";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLoanAgreement(_response));
        });
    }

    protected processGetLoanAgreement(response: Response): Promise<GetLoanAgreementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoanAgreementResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLoanAgreementResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDirectDebit(loanId: string): Promise<GetDirectDebitResponse> {
        let url_ = this.baseUrl + "/document/{loanId}/direct-debit";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDirectDebit(_response));
        });
    }

    protected processGetDirectDebit(response: Response): Promise<GetDirectDebitResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDirectDebitResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDirectDebitResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoanDocumentsForAccount(): Promise<GetLoanDocumentsForAccountResponse> {
        let url_ = this.baseUrl + "/document/{accountId}/loan-documents-for-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLoanDocumentsForAccount(_response));
        });
    }

    protected processGetLoanDocumentsForAccount(response: Response): Promise<GetLoanDocumentsForAccountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoanDocumentsForAccountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLoanDocumentsForAccountResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoanState(loanId: string): Promise<GetLoanStateResponse> {
        let url_ = this.baseUrl + "/credit/loan-state?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLoanState(_response));
        });
    }

    protected processGetLoanState(response: Response): Promise<GetLoanStateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLoanStateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLoanStateResponse>(null as any);
    }

    /**
     * @return OK
     */
    getOpenLoans(): Promise<GetOpenLoansResponse> {
        let url_ = this.baseUrl + "/credit/open-loans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOpenLoans(_response));
        });
    }

    protected processGetOpenLoans(response: Response): Promise<GetOpenLoansResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOpenLoansResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOpenLoansResponse>(null as any);
    }

    /**
     * @param requireSign (optional) 
     * @param requireDocuments (optional) 
     * @param mandatePending (optional) 
     * @param bankVerificationPending (optional) 
     * @param counterOfferCreated (optional) 
     * @param waitingForAgentApproval (optional) 
     * @param affordabilityChallengeCreated (optional) 
     * @return OK
     */
    waitApplication(loanId: string, timeout: number, requireSign: boolean | undefined, requireDocuments: boolean | undefined, mandatePending: boolean | undefined, bankVerificationPending: boolean | undefined, counterOfferCreated: boolean | undefined, waitingForAgentApproval: boolean | undefined, affordabilityChallengeCreated: boolean | undefined): Promise<WaitApplicationResponse> {
        let url_ = this.baseUrl + "/credit/application-state/{loanId}?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined.");
        url_ = url_.replace("{loanId}", encodeURIComponent("" + loanId));
        if (timeout === undefined || timeout === null)
            throw new globalThis.Error("The parameter 'timeout' must be defined and cannot be null.");
        else
            url_ += "timeout=" + encodeURIComponent("" + timeout) + "&";
        if (requireSign === null)
            throw new globalThis.Error("The parameter 'requireSign' cannot be null.");
        else if (requireSign !== undefined)
            url_ += "requireSign=" + encodeURIComponent("" + requireSign) + "&";
        if (requireDocuments === null)
            throw new globalThis.Error("The parameter 'requireDocuments' cannot be null.");
        else if (requireDocuments !== undefined)
            url_ += "requireDocuments=" + encodeURIComponent("" + requireDocuments) + "&";
        if (mandatePending === null)
            throw new globalThis.Error("The parameter 'mandatePending' cannot be null.");
        else if (mandatePending !== undefined)
            url_ += "mandatePending=" + encodeURIComponent("" + mandatePending) + "&";
        if (bankVerificationPending === null)
            throw new globalThis.Error("The parameter 'bankVerificationPending' cannot be null.");
        else if (bankVerificationPending !== undefined)
            url_ += "bankVerificationPending=" + encodeURIComponent("" + bankVerificationPending) + "&";
        if (counterOfferCreated === null)
            throw new globalThis.Error("The parameter 'counterOfferCreated' cannot be null.");
        else if (counterOfferCreated !== undefined)
            url_ += "counterOfferCreated=" + encodeURIComponent("" + counterOfferCreated) + "&";
        if (waitingForAgentApproval === null)
            throw new globalThis.Error("The parameter 'waitingForAgentApproval' cannot be null.");
        else if (waitingForAgentApproval !== undefined)
            url_ += "waitingForAgentApproval=" + encodeURIComponent("" + waitingForAgentApproval) + "&";
        if (affordabilityChallengeCreated === null)
            throw new globalThis.Error("The parameter 'affordabilityChallengeCreated' cannot be null.");
        else if (affordabilityChallengeCreated !== undefined)
            url_ += "affordabilityChallengeCreated=" + encodeURIComponent("" + affordabilityChallengeCreated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWaitApplication(_response));
        });
    }

    protected processWaitApplication(response: Response): Promise<WaitApplicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WaitApplicationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WaitApplicationResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPaidUpLetter(loanId: string): Promise<GetPaidUpLetterResponse> {
        let url_ = this.baseUrl + "/paid-up-letter?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaidUpLetter(_response));
        });
    }

    protected processGetPaidUpLetter(response: Response): Promise<GetPaidUpLetterResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaidUpLetterResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPaidUpLetterResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPaidUpLetterHeaders(): Promise<GetPaidUpLetterHeadersResponse> {
        let url_ = this.baseUrl + "/paid-up-letter-headers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaidUpLetterHeaders(_response));
        });
    }

    protected processGetPaidUpLetterHeaders(response: Response): Promise<GetPaidUpLetterHeadersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaidUpLetterHeadersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPaidUpLetterHeadersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getProducts(): Promise<ProductDescription[]> {
        let url_ = this.baseUrl + "/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProducts(_response));
        });
    }

    protected processGetProducts(response: Response): Promise<ProductDescription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDescription.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDescription[]>(null as any);
    }

    /**
     * @return OK
     */
    getProduct(productId: string): Promise<Product> {
        let url_ = this.baseUrl + "/products/{productId}";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProduct(_response));
        });
    }

    protected processGetProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    addProduct(body: Product): Promise<Product> {
        let url_ = this.baseUrl + "/products/{productId}/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddProduct(_response));
        });
    }

    protected processAddProduct(response: Response): Promise<Product> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Product.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product>(null as any);
    }

    /**
     * @return OK
     */
    sliderConfig(): Promise<ProductConfig> {
        let url_ = this.baseUrl + "/SliderConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSliderConfig(_response));
        });
    }

    protected processSliderConfig(response: Response): Promise<ProductConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductConfig>(null as any);
    }

    /**
     * @return OK
     */
    getAuthenticatedSliderConfig(): Promise<ProductConfig> {
        let url_ = this.baseUrl + "/AuthenticatedSliderConfig/{accountId}";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthenticatedSliderConfig(_response));
        });
    }

    protected processGetAuthenticatedSliderConfig(response: Response): Promise<ProductConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductConfig.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductConfig>(null as any);
    }

    /**
     * @param includeDeathBenefit (optional) 
     * @return OK
     */
    getInstallmentLoanQuotation(productId: string, loanAmount: number, term: number, salaryDay: number, applicationDate: Date, includeInsurance: boolean, saveQuotation: boolean, includeDeathBenefit: boolean | undefined): Promise<GetInstallmentLoanQuotationResponse> {
        let url_ = this.baseUrl + "/quotation-installment?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (loanAmount === undefined || loanAmount === null)
            throw new globalThis.Error("The parameter 'loanAmount' must be defined and cannot be null.");
        else
            url_ += "loanAmount=" + encodeURIComponent("" + loanAmount) + "&";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (salaryDay === undefined || salaryDay === null)
            throw new globalThis.Error("The parameter 'salaryDay' must be defined and cannot be null.");
        else
            url_ += "salaryDay=" + encodeURIComponent("" + salaryDay) + "&";
        if (applicationDate === undefined || applicationDate === null)
            throw new globalThis.Error("The parameter 'applicationDate' must be defined and cannot be null.");
        else
            url_ += "applicationDate=" + encodeURIComponent(applicationDate ? "" + applicationDate.toISOString() : "") + "&";
        if (includeInsurance === undefined || includeInsurance === null)
            throw new globalThis.Error("The parameter 'includeInsurance' must be defined and cannot be null.");
        else
            url_ += "includeInsurance=" + encodeURIComponent("" + includeInsurance) + "&";
        if (saveQuotation === undefined || saveQuotation === null)
            throw new globalThis.Error("The parameter 'saveQuotation' must be defined and cannot be null.");
        else
            url_ += "saveQuotation=" + encodeURIComponent("" + saveQuotation) + "&";
        if (includeDeathBenefit === null)
            throw new globalThis.Error("The parameter 'includeDeathBenefit' cannot be null.");
        else if (includeDeathBenefit !== undefined)
            url_ += "includeDeathBenefit=" + encodeURIComponent("" + includeDeathBenefit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstallmentLoanQuotation(_response));
        });
    }

    protected processGetInstallmentLoanQuotation(response: Response): Promise<GetInstallmentLoanQuotationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInstallmentLoanQuotationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInstallmentLoanQuotationResponse>(null as any);
    }

    /**
     * @param includeDeathBenefit (optional) 
     * @return OK
     */
    getShortTermLoanQuotation(productId: string, loanAmount: number, term: number, salaryDay: number, applicationDate: Date, includeInsurance: boolean, saveQuotation: boolean, includeDeathBenefit: boolean | undefined): Promise<GetShortTermLoanQuotationResponse> {
        let url_ = this.baseUrl + "/quotation-short-term?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (loanAmount === undefined || loanAmount === null)
            throw new globalThis.Error("The parameter 'loanAmount' must be defined and cannot be null.");
        else
            url_ += "loanAmount=" + encodeURIComponent("" + loanAmount) + "&";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (salaryDay === undefined || salaryDay === null)
            throw new globalThis.Error("The parameter 'salaryDay' must be defined and cannot be null.");
        else
            url_ += "salaryDay=" + encodeURIComponent("" + salaryDay) + "&";
        if (applicationDate === undefined || applicationDate === null)
            throw new globalThis.Error("The parameter 'applicationDate' must be defined and cannot be null.");
        else
            url_ += "applicationDate=" + encodeURIComponent(applicationDate ? "" + applicationDate.toISOString() : "") + "&";
        if (includeInsurance === undefined || includeInsurance === null)
            throw new globalThis.Error("The parameter 'includeInsurance' must be defined and cannot be null.");
        else
            url_ += "includeInsurance=" + encodeURIComponent("" + includeInsurance) + "&";
        if (saveQuotation === undefined || saveQuotation === null)
            throw new globalThis.Error("The parameter 'saveQuotation' must be defined and cannot be null.");
        else
            url_ += "saveQuotation=" + encodeURIComponent("" + saveQuotation) + "&";
        if (includeDeathBenefit === null)
            throw new globalThis.Error("The parameter 'includeDeathBenefit' cannot be null.");
        else if (includeDeathBenefit !== undefined)
            url_ += "includeDeathBenefit=" + encodeURIComponent("" + includeDeathBenefit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShortTermLoanQuotation(_response));
        });
    }

    protected processGetShortTermLoanQuotation(response: Response): Promise<GetShortTermLoanQuotationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortTermLoanQuotationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShortTermLoanQuotationResponse>(null as any);
    }

    /**
     * @param includeDeathBenefit (optional) 
     * @return OK
     */
    getShortTermLoanQuotationAnonymous(productId: string, loanAmount: number, term: number, salaryDay: number, applicationDate: Date, includeInsurance: boolean, saveQuotation: boolean, includeDeathBenefit: boolean | undefined): Promise<GetShortTermLoanQuotationResponse> {
        let url_ = this.baseUrl + "/quotation-short-term-anonymous?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (loanAmount === undefined || loanAmount === null)
            throw new globalThis.Error("The parameter 'loanAmount' must be defined and cannot be null.");
        else
            url_ += "loanAmount=" + encodeURIComponent("" + loanAmount) + "&";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (salaryDay === undefined || salaryDay === null)
            throw new globalThis.Error("The parameter 'salaryDay' must be defined and cannot be null.");
        else
            url_ += "salaryDay=" + encodeURIComponent("" + salaryDay) + "&";
        if (applicationDate === undefined || applicationDate === null)
            throw new globalThis.Error("The parameter 'applicationDate' must be defined and cannot be null.");
        else
            url_ += "applicationDate=" + encodeURIComponent(applicationDate ? "" + applicationDate.toISOString() : "") + "&";
        if (includeInsurance === undefined || includeInsurance === null)
            throw new globalThis.Error("The parameter 'includeInsurance' must be defined and cannot be null.");
        else
            url_ += "includeInsurance=" + encodeURIComponent("" + includeInsurance) + "&";
        if (saveQuotation === undefined || saveQuotation === null)
            throw new globalThis.Error("The parameter 'saveQuotation' must be defined and cannot be null.");
        else
            url_ += "saveQuotation=" + encodeURIComponent("" + saveQuotation) + "&";
        if (includeDeathBenefit === null)
            throw new globalThis.Error("The parameter 'includeDeathBenefit' cannot be null.");
        else if (includeDeathBenefit !== undefined)
            url_ += "includeDeathBenefit=" + encodeURIComponent("" + includeDeathBenefit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShortTermLoanQuotationAnonymous(_response));
        });
    }

    protected processGetShortTermLoanQuotationAnonymous(response: Response): Promise<GetShortTermLoanQuotationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetShortTermLoanQuotationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShortTermLoanQuotationResponse>(null as any);
    }

    /**
     * @param includeDeathBenefit (optional) 
     * @return OK
     */
    getInstallmentLoanQuotationAnonymous(productId: string, loanAmount: number, term: number, salaryDay: number, applicationDate: Date, includeInsurance: boolean, saveQuotation: boolean, includeDeathBenefit: boolean | undefined): Promise<GetInstallmentLoanQuotationResponse> {
        let url_ = this.baseUrl + "/quotation-installment-anonymous?";
        if (productId === undefined || productId === null)
            throw new globalThis.Error("The parameter 'productId' must be defined and cannot be null.");
        else
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (loanAmount === undefined || loanAmount === null)
            throw new globalThis.Error("The parameter 'loanAmount' must be defined and cannot be null.");
        else
            url_ += "loanAmount=" + encodeURIComponent("" + loanAmount) + "&";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (salaryDay === undefined || salaryDay === null)
            throw new globalThis.Error("The parameter 'salaryDay' must be defined and cannot be null.");
        else
            url_ += "salaryDay=" + encodeURIComponent("" + salaryDay) + "&";
        if (applicationDate === undefined || applicationDate === null)
            throw new globalThis.Error("The parameter 'applicationDate' must be defined and cannot be null.");
        else
            url_ += "applicationDate=" + encodeURIComponent(applicationDate ? "" + applicationDate.toISOString() : "") + "&";
        if (includeInsurance === undefined || includeInsurance === null)
            throw new globalThis.Error("The parameter 'includeInsurance' must be defined and cannot be null.");
        else
            url_ += "includeInsurance=" + encodeURIComponent("" + includeInsurance) + "&";
        if (saveQuotation === undefined || saveQuotation === null)
            throw new globalThis.Error("The parameter 'saveQuotation' must be defined and cannot be null.");
        else
            url_ += "saveQuotation=" + encodeURIComponent("" + saveQuotation) + "&";
        if (includeDeathBenefit === null)
            throw new globalThis.Error("The parameter 'includeDeathBenefit' cannot be null.");
        else if (includeDeathBenefit !== undefined)
            url_ += "includeDeathBenefit=" + encodeURIComponent("" + includeDeathBenefit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstallmentLoanQuotationAnonymous(_response));
        });
    }

    protected processGetInstallmentLoanQuotationAnonymous(response: Response): Promise<GetInstallmentLoanQuotationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInstallmentLoanQuotationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInstallmentLoanQuotationResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPublicHolidays(): Promise<GetPublicHolidaysResponse> {
        let url_ = this.baseUrl + "/public-holidays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPublicHolidays(_response));
        });
    }

    protected processGetPublicHolidays(response: Response): Promise<GetPublicHolidaysResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPublicHolidaysResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPublicHolidaysResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPaymentSessionUrl(loanId: string, amount: number): Promise<SessionUrlResponse> {
        let url_ = this.baseUrl + "/repay/session-url?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        if (amount === undefined || amount === null)
            throw new globalThis.Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaymentSessionUrl(_response));
        });
    }

    protected processGetPaymentSessionUrl(response: Response): Promise<SessionUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionUrlResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPaymentRedirectUrl(loanId: string, amount: number, paymentMethod: PaymentMethodEnums): Promise<PaymentRedirectUrlResponse> {
        let url_ = this.baseUrl + "/repay/payment-redirect-url?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        if (amount === undefined || amount === null)
            throw new globalThis.Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (paymentMethod === undefined || paymentMethod === null)
            throw new globalThis.Error("The parameter 'paymentMethod' must be defined and cannot be null.");
        else
            url_ += "paymentMethod=" + encodeURIComponent("" + paymentMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaymentRedirectUrl(_response));
        });
    }

    protected processGetPaymentRedirectUrl(response: Response): Promise<PaymentRedirectUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentRedirectUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentRedirectUrlResponse>(null as any);
    }

    /**
     * @return OK
     */
    logPaymentResult(body: OzowPaymentStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/repay/log-payment-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogPaymentResult(_response));
        });
    }

    protected processLogPaymentResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    logPaymentMethodResult(body: PaymentStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/repay/log-payment-method-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogPaymentMethodResult(_response));
        });
    }

    protected processLogPaymentMethodResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getRepayStatus(loanId: string): Promise<GetRepayStatusResponse> {
        let url_ = this.baseUrl + "/repay/status?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRepayStatus(_response));
        });
    }

    protected processGetRepayStatus(response: Response): Promise<GetRepayStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRepayStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRepayStatusResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSettlementLetter(loanId: string): Promise<SettlementLetterDetailsResponse> {
        let url_ = this.baseUrl + "/settlement-letter?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettlementLetter(_response));
        });
    }

    protected processGetSettlementLetter(response: Response): Promise<SettlementLetterDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettlementLetterDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SettlementLetterDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    hasSettlementLetter(loanId: string): Promise<HasSettlementLetterResponse> {
        let url_ = this.baseUrl + "/has-settlement-letter?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasSettlementLetter(_response));
        });
    }

    protected processHasSettlementLetter(response: Response): Promise<HasSettlementLetterResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HasSettlementLetterResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HasSettlementLetterResponse>(null as any);
    }

    /**
     * @param loanId (optional) 
     * @return OK
     */
    getStatementHeaders(loanId: string | undefined): Promise<GetStatementHeadersResponse> {
        let url_ = this.baseUrl + "/statement-headers?";
        if (loanId === null)
            throw new globalThis.Error("The parameter 'loanId' cannot be null.");
        else if (loanId !== undefined)
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatementHeaders(_response));
        });
    }

    protected processGetStatementHeaders(response: Response): Promise<GetStatementHeadersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStatementHeadersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStatementHeadersResponse>(null as any);
    }

    /**
     * @return OK
     */
    getStatement(statementId: string): Promise<MonthlyStatement> {
        let url_ = this.baseUrl + "/statement?";
        if (statementId === undefined || statementId === null)
            throw new globalThis.Error("The parameter 'statementId' must be defined and cannot be null.");
        else
            url_ += "statementId=" + encodeURIComponent("" + statementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatement(_response));
        });
    }

    protected processGetStatement(response: Response): Promise<MonthlyStatement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyStatement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MonthlyStatement>(null as any);
    }

    /**
     * @return OK
     */
    accountState(): Promise<void> {
        let url_ = this.baseUrl + "/credit/account-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccountState(_response));
        });
    }

    protected processAccountState(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getTransactionById(loanId: string): Promise<Transactions> {
        let url_ = this.baseUrl + "/transactions?";
        if (loanId === undefined || loanId === null)
            throw new globalThis.Error("The parameter 'loanId' must be defined and cannot be null.");
        else
            url_ += "loanId=" + encodeURIComponent("" + loanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTransactionById(_response));
        });
    }

    protected processGetTransactionById(response: Response): Promise<Transactions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Transactions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Transactions>(null as any);
    }
}

export class AcceptAffordabilityChallengeRequestModel implements IAcceptAffordabilityChallengeRequestModel {
    loanId?: string;
    bureauRepaymentOverride?: BureauRepaymentOverride[] | undefined;

    constructor(data?: IAcceptAffordabilityChallengeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            if (Array.isArray(_data["bureauRepaymentOverride"])) {
                this.bureauRepaymentOverride = [] as any;
                for (let item of _data["bureauRepaymentOverride"])
                    this.bureauRepaymentOverride!.push(BureauRepaymentOverride.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AcceptAffordabilityChallengeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptAffordabilityChallengeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        if (Array.isArray(this.bureauRepaymentOverride)) {
            data["bureauRepaymentOverride"] = [];
            for (let item of this.bureauRepaymentOverride)
                data["bureauRepaymentOverride"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAcceptAffordabilityChallengeRequestModel {
    loanId?: string;
    bureauRepaymentOverride?: BureauRepaymentOverride[] | undefined;
}

export class AcceptAffordabilityChallengeResponse implements IAcceptAffordabilityChallengeResponse {

    constructor(data?: IAcceptAffordabilityChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AcceptAffordabilityChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptAffordabilityChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAcceptAffordabilityChallengeResponse {
}

export class AcceptOfferRequest implements IAcceptOfferRequest {
    loanId?: string;

    constructor(data?: IAcceptOfferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): AcceptOfferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptOfferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface IAcceptOfferRequest {
    loanId?: string;
}

export class AcceptOfferResponse implements IAcceptOfferResponse {
    success?: boolean;

    constructor(data?: IAcceptOfferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): AcceptOfferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptOfferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IAcceptOfferResponse {
    success?: boolean;
}

export class Address implements IAddress {
    houseNumber?: string | undefined;
    streetName?: string | undefined;
    town?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.houseNumber = _data["houseNumber"];
            this.streetName = _data["streetName"];
            this.town = _data["town"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["houseNumber"] = this.houseNumber;
        data["streetName"] = this.streetName;
        data["town"] = this.town;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddress {
    houseNumber?: string | undefined;
    streetName?: string | undefined;
    town?: string | undefined;
    postalCode?: string | undefined;
}

export class AddressDetails implements IAddressDetails {
    houseNumber?: string | undefined;
    streetName?: string | undefined;
    town?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IAddressDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.houseNumber = _data["houseNumber"];
            this.streetName = _data["streetName"];
            this.town = _data["town"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): AddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["houseNumber"] = this.houseNumber;
        data["streetName"] = this.streetName;
        data["town"] = this.town;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddressDetails {
    houseNumber?: string | undefined;
    streetName?: string | undefined;
    town?: string | undefined;
    postalCode?: string | undefined;
}

export enum AffordabilityChallengeChangeReason {
    Unspecified = "Unspecified",
    AccountSettled = "AccountSettled",
    PaymentArrangement = "PaymentArrangement",
    IncorrectInstalment = "IncorrectInstalment",
}

export class ApplicationAdvice implements IApplicationAdvice {
    requireSign?: boolean;
    requireDocuments?: boolean;
    counterOffer?: boolean;
    waitForDocumentApproval?: boolean;
    mandatePending?: boolean;
    bankVerificationPending?: boolean;
    affordabilityChallenge?: boolean;

    constructor(data?: IApplicationAdvice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireSign = _data["requireSign"];
            this.requireDocuments = _data["requireDocuments"];
            this.counterOffer = _data["counterOffer"];
            this.waitForDocumentApproval = _data["waitForDocumentApproval"];
            this.mandatePending = _data["mandatePending"];
            this.bankVerificationPending = _data["bankVerificationPending"];
            this.affordabilityChallenge = _data["affordabilityChallenge"];
        }
    }

    static fromJS(data: any): ApplicationAdvice {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAdvice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireSign"] = this.requireSign;
        data["requireDocuments"] = this.requireDocuments;
        data["counterOffer"] = this.counterOffer;
        data["waitForDocumentApproval"] = this.waitForDocumentApproval;
        data["mandatePending"] = this.mandatePending;
        data["bankVerificationPending"] = this.bankVerificationPending;
        data["affordabilityChallenge"] = this.affordabilityChallenge;
        return data;
    }
}

export interface IApplicationAdvice {
    requireSign?: boolean;
    requireDocuments?: boolean;
    counterOffer?: boolean;
    waitForDocumentApproval?: boolean;
    mandatePending?: boolean;
    bankVerificationPending?: boolean;
    affordabilityChallenge?: boolean;
}

export class ApplicationInfo implements IApplicationInfo {
    isOpen?: boolean;
    isClosed?: boolean;
    isReferred?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    ivDocumentsCompleted?: boolean;

    constructor(data?: IApplicationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOpen = _data["isOpen"];
            this.isClosed = _data["isClosed"];
            this.isReferred = _data["isReferred"];
            this.isApproved = _data["isApproved"];
            this.isDeclined = _data["isDeclined"];
            this.ivDocumentsCompleted = _data["ivDocumentsCompleted"];
        }
    }

    static fromJS(data: any): ApplicationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOpen"] = this.isOpen;
        data["isClosed"] = this.isClosed;
        data["isReferred"] = this.isReferred;
        data["isApproved"] = this.isApproved;
        data["isDeclined"] = this.isDeclined;
        data["ivDocumentsCompleted"] = this.ivDocumentsCompleted;
        return data;
    }
}

export interface IApplicationInfo {
    isOpen?: boolean;
    isClosed?: boolean;
    isReferred?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    ivDocumentsCompleted?: boolean;
}

export enum ApplicationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class AvaInfo implements IAvaInfo {
    openBankingCompleted?: boolean;
    pendingOpenBankingOutcome?: boolean;

    constructor(data?: IAvaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openBankingCompleted = _data["openBankingCompleted"];
            this.pendingOpenBankingOutcome = _data["pendingOpenBankingOutcome"];
        }
    }

    static fromJS(data: any): AvaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AvaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openBankingCompleted"] = this.openBankingCompleted;
        data["pendingOpenBankingOutcome"] = this.pendingOpenBankingOutcome;
        return data;
    }
}

export interface IAvaInfo {
    openBankingCompleted?: boolean;
    pendingOpenBankingOutcome?: boolean;
}

export class BankVerification implements IBankVerification {
    verifiedOn?: Date | undefined;
    sentOn?: Date | undefined;
    failedOn?: Date | undefined;

    constructor(data?: IBankVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
            this.sentOn = _data["sentOn"] ? new Date(_data["sentOn"].toString()) : undefined as any;
            this.failedOn = _data["failedOn"] ? new Date(_data["failedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BankVerification {
        data = typeof data === 'object' ? data : {};
        let result = new BankVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        data["sentOn"] = this.sentOn ? this.sentOn.toISOString() : undefined as any;
        data["failedOn"] = this.failedOn ? this.failedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IBankVerification {
    verifiedOn?: Date | undefined;
    sentOn?: Date | undefined;
    failedOn?: Date | undefined;
}

export class BureauRepayment implements IBureauRepayment {
    repaymentId!: string | undefined;
    providerName!: string | undefined;
    industry!: string | undefined;
    industryCode!: string | undefined;
    originalInstallmentAmount!: number;
    minimumAdjustedInstallmentAmount!: number;
    validChangeReasons!: AffordabilityChallengeChangeReason[] | undefined;
    priority!: number;

    constructor(data?: IBureauRepayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repaymentId = _data["repaymentId"];
            this.providerName = _data["providerName"];
            this.industry = _data["industry"];
            this.industryCode = _data["industryCode"];
            this.originalInstallmentAmount = _data["originalInstallmentAmount"];
            this.minimumAdjustedInstallmentAmount = _data["minimumAdjustedInstallmentAmount"];
            if (Array.isArray(_data["validChangeReasons"])) {
                this.validChangeReasons = [] as any;
                for (let item of _data["validChangeReasons"])
                    this.validChangeReasons!.push(item);
            }
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): BureauRepayment {
        data = typeof data === 'object' ? data : {};
        let result = new BureauRepayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repaymentId"] = this.repaymentId;
        data["providerName"] = this.providerName;
        data["industry"] = this.industry;
        data["industryCode"] = this.industryCode;
        data["originalInstallmentAmount"] = this.originalInstallmentAmount;
        data["minimumAdjustedInstallmentAmount"] = this.minimumAdjustedInstallmentAmount;
        if (Array.isArray(this.validChangeReasons)) {
            data["validChangeReasons"] = [];
            for (let item of this.validChangeReasons)
                data["validChangeReasons"].push(item);
        }
        data["priority"] = this.priority;
        return data;
    }
}

export interface IBureauRepayment {
    repaymentId: string | undefined;
    providerName: string | undefined;
    industry: string | undefined;
    industryCode: string | undefined;
    originalInstallmentAmount: number;
    minimumAdjustedInstallmentAmount: number;
    validChangeReasons: AffordabilityChallengeChangeReason[] | undefined;
    priority: number;
}

export class BureauRepaymentOverride implements IBureauRepaymentOverride {
    repaymentId!: string | undefined;
    adjustedInstallmentAmount!: number;
    changeReason!: AffordabilityChallengeChangeReason;
    providerName!: string | undefined;

    constructor(data?: IBureauRepaymentOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repaymentId = _data["repaymentId"];
            this.adjustedInstallmentAmount = _data["adjustedInstallmentAmount"];
            this.changeReason = _data["changeReason"];
            this.providerName = _data["providerName"];
        }
    }

    static fromJS(data: any): BureauRepaymentOverride {
        data = typeof data === 'object' ? data : {};
        let result = new BureauRepaymentOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repaymentId"] = this.repaymentId;
        data["adjustedInstallmentAmount"] = this.adjustedInstallmentAmount;
        data["changeReason"] = this.changeReason;
        data["providerName"] = this.providerName;
        return data;
    }
}

export interface IBureauRepaymentOverride {
    repaymentId: string | undefined;
    adjustedInstallmentAmount: number;
    changeReason: AffordabilityChallengeChangeReason;
    providerName: string | undefined;
}

export class CanApplyResponse implements ICanApplyResponse {
    canApply?: boolean;
    verificationResult?: StartApplicationVerificationResult;
    errors?: string[] | undefined;

    constructor(data?: ICanApplyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canApply = _data["canApply"];
            this.verificationResult = _data["verificationResult"] ? StartApplicationVerificationResult.fromJS(_data["verificationResult"]) : undefined as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): CanApplyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CanApplyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canApply"] = this.canApply;
        data["verificationResult"] = this.verificationResult ? this.verificationResult.toJSON() : undefined as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ICanApplyResponse {
    canApply?: boolean;
    verificationResult?: StartApplicationVerificationResult;
    errors?: string[] | undefined;
}

export class CanUploadDocumentsResponse implements ICanUploadDocumentsResponse {
    canUpload?: boolean;

    constructor(data?: ICanUploadDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canUpload = _data["canUpload"];
        }
    }

    static fromJS(data: any): CanUploadDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CanUploadDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canUpload"] = this.canUpload;
        return data;
    }
}

export interface ICanUploadDocumentsResponse {
    canUpload?: boolean;
}

export class CancelledDeclinedApplicationResponse implements ICancelledDeclinedApplicationResponse {
    loanId?: string;
    appliedDate?: Date;
    term?: number;
    termInDays?: number;
    loanAmount?: number;
    isDeclined?: boolean;
    isCancelled?: boolean;
    reason?: UnifiedLoanReason;

    constructor(data?: ICancelledDeclinedApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.appliedDate = _data["appliedDate"] ? new Date(_data["appliedDate"].toString()) : undefined as any;
            this.term = _data["term"];
            this.termInDays = _data["termInDays"];
            this.loanAmount = _data["loanAmount"];
            this.isDeclined = _data["isDeclined"];
            this.isCancelled = _data["isCancelled"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelledDeclinedApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelledDeclinedApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["appliedDate"] = this.appliedDate ? this.appliedDate.toISOString() : undefined as any;
        data["term"] = this.term;
        data["termInDays"] = this.termInDays;
        data["loanAmount"] = this.loanAmount;
        data["isDeclined"] = this.isDeclined;
        data["isCancelled"] = this.isCancelled;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelledDeclinedApplicationResponse {
    loanId?: string;
    appliedDate?: Date;
    term?: number;
    termInDays?: number;
    loanAmount?: number;
    isDeclined?: boolean;
    isCancelled?: boolean;
    reason?: UnifiedLoanReason;
}

export class ClientWatermark implements IClientWatermark {
    blackBoxName?: string | undefined;
    blackBoxData?: string | undefined;

    constructor(data?: IClientWatermark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blackBoxName = _data["blackBoxName"];
            this.blackBoxData = _data["blackBoxData"];
        }
    }

    static fromJS(data: any): ClientWatermark {
        data = typeof data === 'object' ? data : {};
        let result = new ClientWatermark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blackBoxName"] = this.blackBoxName;
        data["blackBoxData"] = this.blackBoxData;
        return data;
    }
}

export interface IClientWatermark {
    blackBoxName?: string | undefined;
    blackBoxData?: string | undefined;
}

export class CompleteUploadRequest implements ICompleteUploadRequest {
    loanId?: string;
    doneSaving?: boolean;
    documentIds?: string[] | undefined;

    constructor(data?: ICompleteUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.doneSaving = _data["doneSaving"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CompleteUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["doneSaving"] = this.doneSaving;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface ICompleteUploadRequest {
    loanId?: string;
    doneSaving?: boolean;
    documentIds?: string[] | undefined;
}

export class CounterOfferResponse implements ICounterOfferResponse {
    quotationData?: QuotationData;
    isIl?: boolean;

    constructor(data?: ICounterOfferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationData = _data["quotationData"] ? QuotationData.fromJS(_data["quotationData"]) : undefined as any;
            this.isIl = _data["isIl"];
        }
    }

    static fromJS(data: any): CounterOfferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CounterOfferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationData"] = this.quotationData ? this.quotationData.toJSON() : undefined as any;
        data["isIl"] = this.isIl;
        return data;
    }
}

export interface ICounterOfferResponse {
    quotationData?: QuotationData;
    isIl?: boolean;
}

export class Customer implements ICustomer {
    firstName?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    easyPayNumber?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.idNumber = _data["idNumber"];
            this.easyPayNumber = _data["easyPayNumber"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["idNumber"] = this.idNumber;
        data["easyPayNumber"] = this.easyPayNumber;
        return data;
    }
}

export interface ICustomer {
    firstName?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    easyPayNumber?: string | undefined;
}

export class CustomerDetails implements ICustomerDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    easyPayNumber?: string | undefined;

    constructor(data?: ICustomerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.idNumber = _data["idNumber"];
            this.easyPayNumber = _data["easyPayNumber"];
        }
    }

    static fromJS(data: any): CustomerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["idNumber"] = this.idNumber;
        data["easyPayNumber"] = this.easyPayNumber;
        return data;
    }
}

export interface ICustomerDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    idNumber?: string | undefined;
    easyPayNumber?: string | undefined;
}

export class DeathBenefitPolicy implements IDeathBenefitPolicy {
    beneficiaryFirstName?: string | undefined;
    beneficiaryLastName?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryContact?: string | undefined;

    constructor(data?: IDeathBenefitPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiaryFirstName = _data["beneficiaryFirstName"];
            this.beneficiaryLastName = _data["beneficiaryLastName"];
            this.beneficiaryRelationship = _data["beneficiaryRelationship"];
            this.beneficiaryContact = _data["beneficiaryContact"];
        }
    }

    static fromJS(data: any): DeathBenefitPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new DeathBenefitPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiaryFirstName"] = this.beneficiaryFirstName;
        data["beneficiaryLastName"] = this.beneficiaryLastName;
        data["beneficiaryRelationship"] = this.beneficiaryRelationship;
        data["beneficiaryContact"] = this.beneficiaryContact;
        return data;
    }
}

export interface IDeathBenefitPolicy {
    beneficiaryFirstName?: string | undefined;
    beneficiaryLastName?: string | undefined;
    beneficiaryRelationship?: string | undefined;
    beneficiaryContact?: string | undefined;
}

export class DeathBenefitQuotationData implements IDeathBenefitQuotationData {
    deathBenefitPremium?: number | undefined;
    contractValue?: number | undefined;
    totalCoverAmount?: number | undefined;

    constructor(data?: IDeathBenefitQuotationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deathBenefitPremium = _data["deathBenefitPremium"];
            this.contractValue = _data["contractValue"];
            this.totalCoverAmount = _data["totalCoverAmount"];
        }
    }

    static fromJS(data: any): DeathBenefitQuotationData {
        data = typeof data === 'object' ? data : {};
        let result = new DeathBenefitQuotationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deathBenefitPremium"] = this.deathBenefitPremium;
        data["contractValue"] = this.contractValue;
        data["totalCoverAmount"] = this.totalCoverAmount;
        return data;
    }
}

export interface IDeathBenefitQuotationData {
    deathBenefitPremium?: number | undefined;
    contractValue?: number | undefined;
    totalCoverAmount?: number | undefined;
}

export class DebitOrderSchedule implements IDebitOrderSchedule {
    transactionType?: TransactionTypeEnum;
    transactionDate?: Date;
    transactionAmount?: number;

    constructor(data?: IDebitOrderSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionType = _data["transactionType"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.transactionAmount = _data["transactionAmount"];
        }
    }

    static fromJS(data: any): DebitOrderSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new DebitOrderSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionType"] = this.transactionType;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : undefined as any;
        data["transactionAmount"] = this.transactionAmount;
        return data;
    }
}

export interface IDebitOrderSchedule {
    transactionType?: TransactionTypeEnum;
    transactionDate?: Date;
    transactionAmount?: number;
}

export class DebtSaleStatus implements IDebtSaleStatus {
    isDebtSold?: boolean;

    constructor(data?: IDebtSaleStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDebtSold = _data["isDebtSold"];
        }
    }

    static fromJS(data: any): DebtSaleStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DebtSaleStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDebtSold"] = this.isDebtSold;
        return data;
    }
}

export interface IDebtSaleStatus {
    isDebtSold?: boolean;
}

export class DebtSaleStatusResponse implements IDebtSaleStatusResponse {
    debtSaleStatus?: DebtSaleStatus;

    constructor(data?: IDebtSaleStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.debtSaleStatus = _data["debtSaleStatus"] ? DebtSaleStatus.fromJS(_data["debtSaleStatus"]) : undefined as any;
        }
    }

    static fromJS(data: any): DebtSaleStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DebtSaleStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["debtSaleStatus"] = this.debtSaleStatus ? this.debtSaleStatus.toJSON() : undefined as any;
        return data;
    }
}

export interface IDebtSaleStatusResponse {
    debtSaleStatus?: DebtSaleStatus;
}

export class DecisionResponse implements IDecisionResponse {
    isCreated?: boolean;
    isStarted?: boolean;
    isCompleted?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    isReferred?: boolean;

    constructor(data?: IDecisionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCreated = _data["isCreated"];
            this.isStarted = _data["isStarted"];
            this.isCompleted = _data["isCompleted"];
            this.isApproved = _data["isApproved"];
            this.isDeclined = _data["isDeclined"];
            this.isReferred = _data["isReferred"];
        }
    }

    static fromJS(data: any): DecisionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecisionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCreated"] = this.isCreated;
        data["isStarted"] = this.isStarted;
        data["isCompleted"] = this.isCompleted;
        data["isApproved"] = this.isApproved;
        data["isDeclined"] = this.isDeclined;
        data["isReferred"] = this.isReferred;
        return data;
    }
}

export interface IDecisionResponse {
    isCreated?: boolean;
    isStarted?: boolean;
    isCompleted?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    isReferred?: boolean;
}

export class DeclineApplicationRequest implements IDeclineApplicationRequest {
    loanId?: string;

    constructor(data?: IDeclineApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): DeclineApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface IDeclineApplicationRequest {
    loanId?: string;
}

export class DeclineApplicationResponse implements IDeclineApplicationResponse {
    success?: boolean;

    constructor(data?: IDeclineApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeclineApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeclineApplicationResponse {
    success?: boolean;
}

export class DeclineLoanAgreementRequest implements IDeclineLoanAgreementRequest {
    loanId?: string;

    constructor(data?: IDeclineLoanAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): DeclineLoanAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineLoanAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface IDeclineLoanAgreementRequest {
    loanId?: string;
}

export class DeclineLoanAgreementResponse implements IDeclineLoanAgreementResponse {
    success?: boolean;

    constructor(data?: IDeclineLoanAgreementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeclineLoanAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineLoanAgreementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeclineLoanAgreementResponse {
    success?: boolean;
}

export class DeclineReasonResponse implements IDeclineReasonResponse {
    declineReason?: HighLevelDeclineReason;

    constructor(data?: IDeclineReasonResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declineReason = _data["declineReason"];
        }
    }

    static fromJS(data: any): DeclineReasonResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineReasonResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declineReason"] = this.declineReason;
        return data;
    }
}

export interface IDeclineReasonResponse {
    declineReason?: HighLevelDeclineReason;
}

export class ErrorResponse implements IErrorResponse {
    message?: string | undefined;
    errorCode?: number;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IErrorResponse {
    message?: string | undefined;
    errorCode?: number;
}

export class GetAffordabilityChallengeResponseModel implements IGetAffordabilityChallengeResponseModel {
    disposableIncome!: number;
    netMonthlyIncome!: number;
    bureauRepayments!: BureauRepayment[] | undefined;

    constructor(data?: IGetAffordabilityChallengeResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disposableIncome = _data["disposableIncome"];
            this.netMonthlyIncome = _data["netMonthlyIncome"];
            if (Array.isArray(_data["bureauRepayments"])) {
                this.bureauRepayments = [] as any;
                for (let item of _data["bureauRepayments"])
                    this.bureauRepayments!.push(BureauRepayment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAffordabilityChallengeResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAffordabilityChallengeResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disposableIncome"] = this.disposableIncome;
        data["netMonthlyIncome"] = this.netMonthlyIncome;
        if (Array.isArray(this.bureauRepayments)) {
            data["bureauRepayments"] = [];
            for (let item of this.bureauRepayments)
                data["bureauRepayments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetAffordabilityChallengeResponseModel {
    disposableIncome: number;
    netMonthlyIncome: number;
    bureauRepayments: BureauRepayment[] | undefined;
}

export class GetCancelledDeclinedApplicationsApiResponse implements IGetCancelledDeclinedApplicationsApiResponse {
    applications?: CancelledDeclinedApplicationResponse[] | undefined;

    constructor(data?: IGetCancelledDeclinedApplicationsApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(CancelledDeclinedApplicationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCancelledDeclinedApplicationsApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCancelledDeclinedApplicationsApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCancelledDeclinedApplicationsApiResponse {
    applications?: CancelledDeclinedApplicationResponse[] | undefined;
}

export class GetDebitOrderScheduleResponse implements IGetDebitOrderScheduleResponse {
    debitOrderSchedules?: DebitOrderSchedule[] | undefined;

    constructor(data?: IGetDebitOrderScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["debitOrderSchedules"])) {
                this.debitOrderSchedules = [] as any;
                for (let item of _data["debitOrderSchedules"])
                    this.debitOrderSchedules!.push(DebitOrderSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDebitOrderScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDebitOrderScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.debitOrderSchedules)) {
            data["debitOrderSchedules"] = [];
            for (let item of this.debitOrderSchedules)
                data["debitOrderSchedules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetDebitOrderScheduleResponse {
    debitOrderSchedules?: DebitOrderSchedule[] | undefined;
}

export class GetDirectDebitResponse implements IGetDirectDebitResponse {
    documentId?: string;
    url?: string | undefined;

    constructor(data?: IGetDirectDebitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetDirectDebitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectDebitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetDirectDebitResponse {
    documentId?: string;
    url?: string | undefined;
}

export class GetInstallmentLoanQuotationResponse implements IGetInstallmentLoanQuotationResponse {
    quotationId?: string;
    productId?: string;
    loanAmount?: number;
    totalRepayable?: number;
    installmentAmount?: number;
    initiationFee?: number;
    serviceFee?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    interestRate?: number;
    insuranceFee?: number;
    term?: number;
    termInDays?: number;
    salaryDay?: number;
    applicationDate?: Date;
    promiseDate?: Date;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefitPremium?: number | undefined;
    deathBenefitContractValue?: number | undefined;
    deathBenefitTotalCover?: number | undefined;

    constructor(data?: IGetInstallmentLoanQuotationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationId = _data["quotationId"];
            this.productId = _data["productId"];
            this.loanAmount = _data["loanAmount"];
            this.totalRepayable = _data["totalRepayable"];
            this.installmentAmount = _data["installmentAmount"];
            this.initiationFee = _data["initiationFee"];
            this.serviceFee = _data["serviceFee"];
            this.totalServiceFees = _data["totalServiceFees"];
            this.interestAmount = _data["interestAmount"];
            this.interestRate = _data["interestRate"];
            this.insuranceFee = _data["insuranceFee"];
            this.term = _data["term"];
            this.termInDays = _data["termInDays"];
            this.salaryDay = _data["salaryDay"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.promiseDate = _data["promiseDate"] ? new Date(_data["promiseDate"].toString()) : undefined as any;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            if (Array.isArray(_data["collectionDates"])) {
                this.collectionDates = [] as any;
                for (let item of _data["collectionDates"])
                    this.collectionDates!.push(new Date(item));
            }
            this.deathBenefitPremium = _data["deathBenefitPremium"];
            this.deathBenefitContractValue = _data["deathBenefitContractValue"];
            this.deathBenefitTotalCover = _data["deathBenefitTotalCover"];
        }
    }

    static fromJS(data: any): GetInstallmentLoanQuotationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInstallmentLoanQuotationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationId"] = this.quotationId;
        data["productId"] = this.productId;
        data["loanAmount"] = this.loanAmount;
        data["totalRepayable"] = this.totalRepayable;
        data["installmentAmount"] = this.installmentAmount;
        data["initiationFee"] = this.initiationFee;
        data["serviceFee"] = this.serviceFee;
        data["totalServiceFees"] = this.totalServiceFees;
        data["interestAmount"] = this.interestAmount;
        data["interestRate"] = this.interestRate;
        data["insuranceFee"] = this.insuranceFee;
        data["term"] = this.term;
        data["termInDays"] = this.termInDays;
        data["salaryDay"] = this.salaryDay;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["promiseDate"] = this.promiseDate ? this.promiseDate.toISOString() : undefined as any;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        if (Array.isArray(this.collectionDates)) {
            data["collectionDates"] = [];
            for (let item of this.collectionDates)
                data["collectionDates"].push(item.toISOString());
        }
        data["deathBenefitPremium"] = this.deathBenefitPremium;
        data["deathBenefitContractValue"] = this.deathBenefitContractValue;
        data["deathBenefitTotalCover"] = this.deathBenefitTotalCover;
        return data;
    }
}

export interface IGetInstallmentLoanQuotationResponse {
    quotationId?: string;
    productId?: string;
    loanAmount?: number;
    totalRepayable?: number;
    installmentAmount?: number;
    initiationFee?: number;
    serviceFee?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    interestRate?: number;
    insuranceFee?: number;
    term?: number;
    termInDays?: number;
    salaryDay?: number;
    applicationDate?: Date;
    promiseDate?: Date;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefitPremium?: number | undefined;
    deathBenefitContractValue?: number | undefined;
    deathBenefitTotalCover?: number | undefined;
}

export class GetLoanAgreementResponse implements IGetLoanAgreementResponse {
    documentId?: string;
    url?: string | undefined;

    constructor(data?: IGetLoanAgreementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): GetLoanAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoanAgreementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["url"] = this.url;
        return data;
    }
}

export interface IGetLoanAgreementResponse {
    documentId?: string;
    url?: string | undefined;
}

export class GetLoanDocumentsForAccountResponse implements IGetLoanDocumentsForAccountResponse {
    loanDocumentHeaders?: LoanDocumentHeader[] | undefined;

    constructor(data?: IGetLoanDocumentsForAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["loanDocumentHeaders"])) {
                this.loanDocumentHeaders = [] as any;
                for (let item of _data["loanDocumentHeaders"])
                    this.loanDocumentHeaders!.push(LoanDocumentHeader.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLoanDocumentsForAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoanDocumentsForAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loanDocumentHeaders)) {
            data["loanDocumentHeaders"] = [];
            for (let item of this.loanDocumentHeaders)
                data["loanDocumentHeaders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetLoanDocumentsForAccountResponse {
    loanDocumentHeaders?: LoanDocumentHeader[] | undefined;
}

export class GetLoanStateResponse implements IGetLoanStateResponse {
    applicationAdvice?: ApplicationAdvice;
    applicationInfo?: ApplicationInfo;
    loanInfo?: LoanInfo;
    applicationStatus?: ApplicationStatus;
    mandateInfo?: MandateInfo;
    bankVerification?: BankVerification;
    avaInfo?: AvaInfo;

    constructor(data?: IGetLoanStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationAdvice = _data["applicationAdvice"] ? ApplicationAdvice.fromJS(_data["applicationAdvice"]) : undefined as any;
            this.applicationInfo = _data["applicationInfo"] ? ApplicationInfo.fromJS(_data["applicationInfo"]) : undefined as any;
            this.loanInfo = _data["loanInfo"] ? LoanInfo.fromJS(_data["loanInfo"]) : undefined as any;
            this.applicationStatus = _data["applicationStatus"];
            this.mandateInfo = _data["mandateInfo"] ? MandateInfo.fromJS(_data["mandateInfo"]) : undefined as any;
            this.bankVerification = _data["bankVerification"] ? BankVerification.fromJS(_data["bankVerification"]) : undefined as any;
            this.avaInfo = _data["avaInfo"] ? AvaInfo.fromJS(_data["avaInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetLoanStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoanStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationAdvice"] = this.applicationAdvice ? this.applicationAdvice.toJSON() : undefined as any;
        data["applicationInfo"] = this.applicationInfo ? this.applicationInfo.toJSON() : undefined as any;
        data["loanInfo"] = this.loanInfo ? this.loanInfo.toJSON() : undefined as any;
        data["applicationStatus"] = this.applicationStatus;
        data["mandateInfo"] = this.mandateInfo ? this.mandateInfo.toJSON() : undefined as any;
        data["bankVerification"] = this.bankVerification ? this.bankVerification.toJSON() : undefined as any;
        data["avaInfo"] = this.avaInfo ? this.avaInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetLoanStateResponse {
    applicationAdvice?: ApplicationAdvice;
    applicationInfo?: ApplicationInfo;
    loanInfo?: LoanInfo;
    applicationStatus?: ApplicationStatus;
    mandateInfo?: MandateInfo;
    bankVerification?: BankVerification;
    avaInfo?: AvaInfo;
}

export class GetLoansSummaryResponse implements IGetLoansSummaryResponse {
    hasOpenLoanOrApplication?: boolean;
    isDne?: boolean;
    canApply?: boolean;
    maxLoanAmount?: number | undefined;
    loans?: LiveLoan[] | undefined;
    openApplication?: OpenApplication;
    disbursementCoolingOff?: boolean;
    disbursementCoolOffDays?: number;

    constructor(data?: IGetLoansSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasOpenLoanOrApplication = _data["hasOpenLoanOrApplication"];
            this.isDne = _data["isDne"];
            this.canApply = _data["canApply"];
            this.maxLoanAmount = _data["maxLoanAmount"];
            if (Array.isArray(_data["loans"])) {
                this.loans = [] as any;
                for (let item of _data["loans"])
                    this.loans!.push(LiveLoan.fromJS(item));
            }
            this.openApplication = _data["openApplication"] ? OpenApplication.fromJS(_data["openApplication"]) : undefined as any;
            this.disbursementCoolingOff = _data["disbursementCoolingOff"];
            this.disbursementCoolOffDays = _data["disbursementCoolOffDays"];
        }
    }

    static fromJS(data: any): GetLoansSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLoansSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOpenLoanOrApplication"] = this.hasOpenLoanOrApplication;
        data["isDne"] = this.isDne;
        data["canApply"] = this.canApply;
        data["maxLoanAmount"] = this.maxLoanAmount;
        if (Array.isArray(this.loans)) {
            data["loans"] = [];
            for (let item of this.loans)
                data["loans"].push(item ? item.toJSON() : undefined as any);
        }
        data["openApplication"] = this.openApplication ? this.openApplication.toJSON() : undefined as any;
        data["disbursementCoolingOff"] = this.disbursementCoolingOff;
        data["disbursementCoolOffDays"] = this.disbursementCoolOffDays;
        return data;
    }
}

export interface IGetLoansSummaryResponse {
    hasOpenLoanOrApplication?: boolean;
    isDne?: boolean;
    canApply?: boolean;
    maxLoanAmount?: number | undefined;
    loans?: LiveLoan[] | undefined;
    openApplication?: OpenApplication;
    disbursementCoolingOff?: boolean;
    disbursementCoolOffDays?: number;
}

export class GetOpenLoansResponse implements IGetOpenLoansResponse {
    latestOpenLoan?: LoanResponse;
    readonly openLoans?: LoanResponse[] | undefined;

    constructor(data?: IGetOpenLoansResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latestOpenLoan = _data["latestOpenLoan"] ? LoanResponse.fromJS(_data["latestOpenLoan"]) : undefined as any;
            if (Array.isArray(_data["openLoans"])) {
                (this as any).openLoans = [] as any;
                for (let item of _data["openLoans"])
                    (this as any).openLoans!.push(LoanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOpenLoansResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOpenLoansResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestOpenLoan"] = this.latestOpenLoan ? this.latestOpenLoan.toJSON() : undefined as any;
        if (Array.isArray(this.openLoans)) {
            data["openLoans"] = [];
            for (let item of this.openLoans)
                data["openLoans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetOpenLoansResponse {
    latestOpenLoan?: LoanResponse;
    openLoans?: LoanResponse[] | undefined;
}

export class GetPaidUpLetterHeadersResponse implements IGetPaidUpLetterHeadersResponse {
    paidUpLetterHeaders?: PaidUpLetterHeader[] | undefined;

    constructor(data?: IGetPaidUpLetterHeadersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paidUpLetterHeaders"])) {
                this.paidUpLetterHeaders = [] as any;
                for (let item of _data["paidUpLetterHeaders"])
                    this.paidUpLetterHeaders!.push(PaidUpLetterHeader.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaidUpLetterHeadersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaidUpLetterHeadersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paidUpLetterHeaders)) {
            data["paidUpLetterHeaders"] = [];
            for (let item of this.paidUpLetterHeaders)
                data["paidUpLetterHeaders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPaidUpLetterHeadersResponse {
    paidUpLetterHeaders?: PaidUpLetterHeader[] | undefined;
}

export class GetPaidUpLetterResponse implements IGetPaidUpLetterResponse {
    paidUpLetter?: PaidUpLetter;

    constructor(data?: IGetPaidUpLetterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidUpLetter = _data["paidUpLetter"] ? PaidUpLetter.fromJS(_data["paidUpLetter"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetPaidUpLetterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaidUpLetterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidUpLetter"] = this.paidUpLetter ? this.paidUpLetter.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetPaidUpLetterResponse {
    paidUpLetter?: PaidUpLetter;
}

export class GetPublicHolidaysResponse implements IGetPublicHolidaysResponse {
    publicHolidays?: Date[] | undefined;

    constructor(data?: IGetPublicHolidaysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["publicHolidays"])) {
                this.publicHolidays = [] as any;
                for (let item of _data["publicHolidays"])
                    this.publicHolidays!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): GetPublicHolidaysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicHolidaysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.publicHolidays)) {
            data["publicHolidays"] = [];
            for (let item of this.publicHolidays)
                data["publicHolidays"].push(item.toISOString());
        }
        return data;
    }
}

export interface IGetPublicHolidaysResponse {
    publicHolidays?: Date[] | undefined;
}

export class GetRepayStatusResponse implements IGetRepayStatusResponse {
    enabled?: boolean;

    constructor(data?: IGetRepayStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): GetRepayStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRepayStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IGetRepayStatusResponse {
    enabled?: boolean;
}

export class GetShortTermLoanQuotationResponse implements IGetShortTermLoanQuotationResponse {
    quotationId?: string;
    productId?: string;
    loanAmount?: number;
    totalRepayable?: number;
    initiationFee?: number;
    serviceFee?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    interestRate?: number;
    insuranceFee?: number;
    term?: number;
    salaryDay?: number;
    applicationDate?: Date;
    promiseDate?: Date;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefitPremium?: number | undefined;
    deathBenefitContractValue?: number | undefined;
    deathBenefitTotalCover?: number | undefined;

    constructor(data?: IGetShortTermLoanQuotationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationId = _data["quotationId"];
            this.productId = _data["productId"];
            this.loanAmount = _data["loanAmount"];
            this.totalRepayable = _data["totalRepayable"];
            this.initiationFee = _data["initiationFee"];
            this.serviceFee = _data["serviceFee"];
            this.totalServiceFees = _data["totalServiceFees"];
            this.interestAmount = _data["interestAmount"];
            this.interestRate = _data["interestRate"];
            this.insuranceFee = _data["insuranceFee"];
            this.term = _data["term"];
            this.salaryDay = _data["salaryDay"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.promiseDate = _data["promiseDate"] ? new Date(_data["promiseDate"].toString()) : undefined as any;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            if (Array.isArray(_data["collectionDates"])) {
                this.collectionDates = [] as any;
                for (let item of _data["collectionDates"])
                    this.collectionDates!.push(new Date(item));
            }
            this.deathBenefitPremium = _data["deathBenefitPremium"];
            this.deathBenefitContractValue = _data["deathBenefitContractValue"];
            this.deathBenefitTotalCover = _data["deathBenefitTotalCover"];
        }
    }

    static fromJS(data: any): GetShortTermLoanQuotationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetShortTermLoanQuotationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationId"] = this.quotationId;
        data["productId"] = this.productId;
        data["loanAmount"] = this.loanAmount;
        data["totalRepayable"] = this.totalRepayable;
        data["initiationFee"] = this.initiationFee;
        data["serviceFee"] = this.serviceFee;
        data["totalServiceFees"] = this.totalServiceFees;
        data["interestAmount"] = this.interestAmount;
        data["interestRate"] = this.interestRate;
        data["insuranceFee"] = this.insuranceFee;
        data["term"] = this.term;
        data["salaryDay"] = this.salaryDay;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["promiseDate"] = this.promiseDate ? this.promiseDate.toISOString() : undefined as any;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        if (Array.isArray(this.collectionDates)) {
            data["collectionDates"] = [];
            for (let item of this.collectionDates)
                data["collectionDates"].push(item.toISOString());
        }
        data["deathBenefitPremium"] = this.deathBenefitPremium;
        data["deathBenefitContractValue"] = this.deathBenefitContractValue;
        data["deathBenefitTotalCover"] = this.deathBenefitTotalCover;
        return data;
    }
}

export interface IGetShortTermLoanQuotationResponse {
    quotationId?: string;
    productId?: string;
    loanAmount?: number;
    totalRepayable?: number;
    initiationFee?: number;
    serviceFee?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    interestRate?: number;
    insuranceFee?: number;
    term?: number;
    salaryDay?: number;
    applicationDate?: Date;
    promiseDate?: Date;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefitPremium?: number | undefined;
    deathBenefitContractValue?: number | undefined;
    deathBenefitTotalCover?: number | undefined;
}

export class GetStatementHeadersResponse implements IGetStatementHeadersResponse {
    statementHeaders?: StatementHeader[] | undefined;

    constructor(data?: IGetStatementHeadersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statementHeaders"])) {
                this.statementHeaders = [] as any;
                for (let item of _data["statementHeaders"])
                    this.statementHeaders!.push(StatementHeader.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStatementHeadersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatementHeadersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statementHeaders)) {
            data["statementHeaders"] = [];
            for (let item of this.statementHeaders)
                data["statementHeaders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetStatementHeadersResponse {
    statementHeaders?: StatementHeader[] | undefined;
}

export class HasOpenLoanOrApplicationsResponse implements IHasOpenLoanOrApplicationsResponse {
    hasOpenLoanOrApplications?: boolean;

    constructor(data?: IHasOpenLoanOrApplicationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasOpenLoanOrApplications = _data["hasOpenLoanOrApplications"];
        }
    }

    static fromJS(data: any): HasOpenLoanOrApplicationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HasOpenLoanOrApplicationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOpenLoanOrApplications"] = this.hasOpenLoanOrApplications;
        return data;
    }
}

export interface IHasOpenLoanOrApplicationsResponse {
    hasOpenLoanOrApplications?: boolean;
}

export class HasSettlementLetterResponse implements IHasSettlementLetterResponse {
    hasSettlementLetter?: boolean;
    validTo?: Date | undefined;

    constructor(data?: IHasSettlementLetterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSettlementLetter = _data["hasSettlementLetter"];
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HasSettlementLetterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HasSettlementLetterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSettlementLetter"] = this.hasSettlementLetter;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface IHasSettlementLetterResponse {
    hasSettlementLetter?: boolean;
    validTo?: Date | undefined;
}

export class HealthResponse implements IHealthResponse {
    healthy?: boolean;

    constructor(data?: IHealthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthy = _data["healthy"];
        }
    }

    static fromJS(data: any): HealthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthy"] = this.healthy;
        return data;
    }
}

export interface IHealthResponse {
    healthy?: boolean;
}

export enum HighLevelDeclineReason {
    Unspecified = "Unspecified",
    GeneralDecline = "GeneralDecline",
    PotentialFraud = "PotentialFraud",
    TransUnionDataNotAvailable = "TransUnionDataNotAvailable",
    RiskScoreTooLow = "RiskScoreTooLow",
    ApplyForLowerAmount = "ApplyForLowerAmount",
    AffordabilityCounterOfferRejected = "AffordabilityCounterOfferRejected",
}

export class IsExistingCustomerResponse implements IIsExistingCustomerResponse {
    isExistingCustomer?: boolean;

    constructor(data?: IIsExistingCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExistingCustomer = _data["isExistingCustomer"];
        }
    }

    static fromJS(data: any): IsExistingCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsExistingCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExistingCustomer"] = this.isExistingCustomer;
        return data;
    }
}

export interface IIsExistingCustomerResponse {
    isExistingCustomer?: boolean;
}

export class LimitPerDuration implements ILimitPerDuration {
    duration?: number;
    amountMax?: number;
    amountMin?: number;

    constructor(data?: ILimitPerDuration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.amountMax = _data["amountMax"];
            this.amountMin = _data["amountMin"];
        }
    }

    static fromJS(data: any): LimitPerDuration {
        data = typeof data === 'object' ? data : {};
        let result = new LimitPerDuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["amountMax"] = this.amountMax;
        data["amountMin"] = this.amountMin;
        return data;
    }
}

export interface ILimitPerDuration {
    duration?: number;
    amountMax?: number;
    amountMin?: number;
}

export class Limits implements ILimits {
    productId?: string;
    limitPerDurations?: LimitPerDuration[] | undefined;

    constructor(data?: ILimits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            if (Array.isArray(_data["limitPerDurations"])) {
                this.limitPerDurations = [] as any;
                for (let item of _data["limitPerDurations"])
                    this.limitPerDurations!.push(LimitPerDuration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Limits {
        data = typeof data === 'object' ? data : {};
        let result = new Limits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        if (Array.isArray(this.limitPerDurations)) {
            data["limitPerDurations"] = [];
            for (let item of this.limitPerDurations)
                data["limitPerDurations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILimits {
    productId?: string;
    limitPerDurations?: LimitPerDuration[] | undefined;
}

export class LiveLoan implements ILiveLoan {
    loanId?: string;
    applicationId?: string;
    productId?: string;
    availableBalance?: number | undefined;
    currentBalance?: number | undefined;
    collectionDate?: Date | undefined;
    collectionInstalment?: number | undefined;
    accruedFees?: number | undefined;
    accruedInterest?: number | undefined;
    accruedCreditLife?: number | undefined;
    totalArrearsAmount?: number | undefined;
    periodInArrears?: number | undefined;
    accountNumber?: string | undefined;
    openLoanStatus?: OpenLoanStatus;
    createdOn?: Date;
    loanAmount?: number;
    term?: number;
    termInDays?: number;

    constructor(data?: ILiveLoan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.applicationId = _data["applicationId"];
            this.productId = _data["productId"];
            this.availableBalance = _data["availableBalance"];
            this.currentBalance = _data["currentBalance"];
            this.collectionDate = _data["collectionDate"] ? new Date(_data["collectionDate"].toString()) : undefined as any;
            this.collectionInstalment = _data["collectionInstalment"];
            this.accruedFees = _data["accruedFees"];
            this.accruedInterest = _data["accruedInterest"];
            this.accruedCreditLife = _data["accruedCreditLife"];
            this.totalArrearsAmount = _data["totalArrearsAmount"];
            this.periodInArrears = _data["periodInArrears"];
            this.accountNumber = _data["accountNumber"];
            this.openLoanStatus = _data["openLoanStatus"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.loanAmount = _data["loanAmount"];
            this.term = _data["term"];
            this.termInDays = _data["termInDays"];
        }
    }

    static fromJS(data: any): LiveLoan {
        data = typeof data === 'object' ? data : {};
        let result = new LiveLoan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["applicationId"] = this.applicationId;
        data["productId"] = this.productId;
        data["availableBalance"] = this.availableBalance;
        data["currentBalance"] = this.currentBalance;
        data["collectionDate"] = this.collectionDate ? this.collectionDate.toISOString() : undefined as any;
        data["collectionInstalment"] = this.collectionInstalment;
        data["accruedFees"] = this.accruedFees;
        data["accruedInterest"] = this.accruedInterest;
        data["accruedCreditLife"] = this.accruedCreditLife;
        data["totalArrearsAmount"] = this.totalArrearsAmount;
        data["periodInArrears"] = this.periodInArrears;
        data["accountNumber"] = this.accountNumber;
        data["openLoanStatus"] = this.openLoanStatus;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["loanAmount"] = this.loanAmount;
        data["term"] = this.term;
        data["termInDays"] = this.termInDays;
        return data;
    }
}

export interface ILiveLoan {
    loanId?: string;
    applicationId?: string;
    productId?: string;
    availableBalance?: number | undefined;
    currentBalance?: number | undefined;
    collectionDate?: Date | undefined;
    collectionInstalment?: number | undefined;
    accruedFees?: number | undefined;
    accruedInterest?: number | undefined;
    accruedCreditLife?: number | undefined;
    totalArrearsAmount?: number | undefined;
    periodInArrears?: number | undefined;
    accountNumber?: string | undefined;
    openLoanStatus?: OpenLoanStatus;
    createdOn?: Date;
    loanAmount?: number;
    term?: number;
    termInDays?: number;
}

export class Loan implements ILoan {
    originalLoanAmount?: number;
    nextInstallmentAmount?: number | undefined;
    monthlyInterestRate?: number;
    term?: number;
    nextInstallmentDueDate?: Date | undefined;
    externalReferenceId?: string | undefined;
    isIl?: boolean;

    constructor(data?: ILoan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalLoanAmount = _data["originalLoanAmount"];
            this.nextInstallmentAmount = _data["nextInstallmentAmount"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.term = _data["term"];
            this.nextInstallmentDueDate = _data["nextInstallmentDueDate"] ? new Date(_data["nextInstallmentDueDate"].toString()) : undefined as any;
            this.externalReferenceId = _data["externalReferenceId"];
            this.isIl = _data["isIl"];
        }
    }

    static fromJS(data: any): Loan {
        data = typeof data === 'object' ? data : {};
        let result = new Loan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalLoanAmount"] = this.originalLoanAmount;
        data["nextInstallmentAmount"] = this.nextInstallmentAmount;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["term"] = this.term;
        data["nextInstallmentDueDate"] = this.nextInstallmentDueDate ? this.nextInstallmentDueDate.toISOString() : undefined as any;
        data["externalReferenceId"] = this.externalReferenceId;
        data["isIl"] = this.isIl;
        return data;
    }
}

export interface ILoan {
    originalLoanAmount?: number;
    nextInstallmentAmount?: number | undefined;
    monthlyInterestRate?: number;
    term?: number;
    nextInstallmentDueDate?: Date | undefined;
    externalReferenceId?: string | undefined;
    isIl?: boolean;
}

export class LoanApplicationRequest implements ILoanApplicationRequest {
    accountId?: string;
    quotationId?: string;
    productId?: string;
    clientWatermark?: ClientWatermark;
    deathBenefitPolicy?: DeathBenefitPolicy;
    loanId?: string | undefined;
    applicationId?: string | undefined;

    constructor(data?: ILoanApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.quotationId = _data["quotationId"];
            this.productId = _data["productId"];
            this.clientWatermark = _data["clientWatermark"] ? ClientWatermark.fromJS(_data["clientWatermark"]) : undefined as any;
            this.deathBenefitPolicy = _data["deathBenefitPolicy"] ? DeathBenefitPolicy.fromJS(_data["deathBenefitPolicy"]) : undefined as any;
            this.loanId = _data["loanId"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): LoanApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoanApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["quotationId"] = this.quotationId;
        data["productId"] = this.productId;
        data["clientWatermark"] = this.clientWatermark ? this.clientWatermark.toJSON() : undefined as any;
        data["deathBenefitPolicy"] = this.deathBenefitPolicy ? this.deathBenefitPolicy.toJSON() : undefined as any;
        data["loanId"] = this.loanId;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface ILoanApplicationRequest {
    accountId?: string;
    quotationId?: string;
    productId?: string;
    clientWatermark?: ClientWatermark;
    deathBenefitPolicy?: DeathBenefitPolicy;
    loanId?: string | undefined;
    applicationId?: string | undefined;
}

export class LoanApplicationResponse implements ILoanApplicationResponse {
    loanId?: string | undefined;
    accountId?: string;
    status?: string | undefined;
    verificationResult?: StartApplicationVerificationResult;

    constructor(data?: ILoanApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.accountId = _data["accountId"];
            this.status = _data["status"];
            this.verificationResult = _data["verificationResult"] ? StartApplicationVerificationResult.fromJS(_data["verificationResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): LoanApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoanApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["accountId"] = this.accountId;
        data["status"] = this.status;
        data["verificationResult"] = this.verificationResult ? this.verificationResult.toJSON() : undefined as any;
        return data;
    }
}

export interface ILoanApplicationResponse {
    loanId?: string | undefined;
    accountId?: string;
    status?: string | undefined;
    verificationResult?: StartApplicationVerificationResult;
}

export class LoanData implements ILoanData {
    loanId?: string;
    applicationId?: string;
    productId?: string;
    availableBalance?: number | undefined;
    currentBalance?: number | undefined;
    collectionDate?: Date | undefined;
    collectionInstalment?: number | undefined;
    accruedFees?: number | undefined;
    accruedInterest?: number | undefined;
    accruedCreditLife?: number | undefined;
    totalArrearsAmount?: number | undefined;
    periodInArrears?: number | undefined;
    accountNumber?: string | undefined;

    constructor(data?: ILoanData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.applicationId = _data["applicationId"];
            this.productId = _data["productId"];
            this.availableBalance = _data["availableBalance"];
            this.currentBalance = _data["currentBalance"];
            this.collectionDate = _data["collectionDate"] ? new Date(_data["collectionDate"].toString()) : undefined as any;
            this.collectionInstalment = _data["collectionInstalment"];
            this.accruedFees = _data["accruedFees"];
            this.accruedInterest = _data["accruedInterest"];
            this.accruedCreditLife = _data["accruedCreditLife"];
            this.totalArrearsAmount = _data["totalArrearsAmount"];
            this.periodInArrears = _data["periodInArrears"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): LoanData {
        data = typeof data === 'object' ? data : {};
        let result = new LoanData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["applicationId"] = this.applicationId;
        data["productId"] = this.productId;
        data["availableBalance"] = this.availableBalance;
        data["currentBalance"] = this.currentBalance;
        data["collectionDate"] = this.collectionDate ? this.collectionDate.toISOString() : undefined as any;
        data["collectionInstalment"] = this.collectionInstalment;
        data["accruedFees"] = this.accruedFees;
        data["accruedInterest"] = this.accruedInterest;
        data["accruedCreditLife"] = this.accruedCreditLife;
        data["totalArrearsAmount"] = this.totalArrearsAmount;
        data["periodInArrears"] = this.periodInArrears;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface ILoanData {
    loanId?: string;
    applicationId?: string;
    productId?: string;
    availableBalance?: number | undefined;
    currentBalance?: number | undefined;
    collectionDate?: Date | undefined;
    collectionInstalment?: number | undefined;
    accruedFees?: number | undefined;
    accruedInterest?: number | undefined;
    accruedCreditLife?: number | undefined;
    totalArrearsAmount?: number | undefined;
    periodInArrears?: number | undefined;
    accountNumber?: string | undefined;
}

export class LoanDocumentHeader implements ILoanDocumentHeader {
    loanId?: string;
    applicationDate?: Date;
    signedOn?: Date;
    term?: number;
    loanStatus?: LoanStatus;
    loanAmount?: number;
    isIl?: boolean;

    constructor(data?: ILoanDocumentHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.signedOn = _data["signedOn"] ? new Date(_data["signedOn"].toString()) : undefined as any;
            this.term = _data["term"];
            this.loanStatus = _data["loanStatus"];
            this.loanAmount = _data["loanAmount"];
            this.isIl = _data["isIl"];
        }
    }

    static fromJS(data: any): LoanDocumentHeader {
        data = typeof data === 'object' ? data : {};
        let result = new LoanDocumentHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["signedOn"] = this.signedOn ? this.signedOn.toISOString() : undefined as any;
        data["term"] = this.term;
        data["loanStatus"] = this.loanStatus;
        data["loanAmount"] = this.loanAmount;
        data["isIl"] = this.isIl;
        return data;
    }
}

export interface ILoanDocumentHeader {
    loanId?: string;
    applicationDate?: Date;
    signedOn?: Date;
    term?: number;
    loanStatus?: LoanStatus;
    loanAmount?: number;
    isIl?: boolean;
}

export class LoanInfo implements ILoanInfo {
    isDisbursed?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isCancelled?: boolean;

    constructor(data?: ILoanInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDisbursed = _data["isDisbursed"];
            this.isOpen = _data["isOpen"];
            this.isClosed = _data["isClosed"];
            this.isCancelled = _data["isCancelled"];
        }
    }

    static fromJS(data: any): LoanInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LoanInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDisbursed"] = this.isDisbursed;
        data["isOpen"] = this.isOpen;
        data["isClosed"] = this.isClosed;
        data["isCancelled"] = this.isCancelled;
        return data;
    }
}

export interface ILoanInfo {
    isDisbursed?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isCancelled?: boolean;
}

export class LoanResponse implements ILoanResponse {
    loanId?: string;
    productId?: string;

    constructor(data?: ILoanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): LoanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["productId"] = this.productId;
        return data;
    }
}

export interface ILoanResponse {
    loanId?: string;
    productId?: string;
}

export enum LoanStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class MandateInfo implements IMandateInfo {
    acceptedOn?: Date | undefined;
    rejectedOn?: Date | undefined;
    referredOn?: Date | undefined;
    workflowStatus?: MandateWorkflowStatus;
    status?: MandateStatus;

    constructor(data?: IMandateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acceptedOn = _data["acceptedOn"] ? new Date(_data["acceptedOn"].toString()) : undefined as any;
            this.rejectedOn = _data["rejectedOn"] ? new Date(_data["rejectedOn"].toString()) : undefined as any;
            this.referredOn = _data["referredOn"] ? new Date(_data["referredOn"].toString()) : undefined as any;
            this.workflowStatus = _data["workflowStatus"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MandateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MandateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptedOn"] = this.acceptedOn ? this.acceptedOn.toISOString() : undefined as any;
        data["rejectedOn"] = this.rejectedOn ? this.rejectedOn.toISOString() : undefined as any;
        data["referredOn"] = this.referredOn ? this.referredOn.toISOString() : undefined as any;
        data["workflowStatus"] = this.workflowStatus;
        data["status"] = this.status;
        return data;
    }
}

export interface IMandateInfo {
    acceptedOn?: Date | undefined;
    rejectedOn?: Date | undefined;
    referredOn?: Date | undefined;
    workflowStatus?: MandateWorkflowStatus;
    status?: MandateStatus;
}

export enum MandateStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum MandateWorkflowStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class MonthlyStatement implements IMonthlyStatement {
    statementDate?: Date;
    startDate?: Date;
    endDate?: Date;
    openingBalance?: number;
    currentBalance?: number;
    closingBalance?: number;
    customer?: CustomerDetails;
    address?: AddressDetails;
    loan?: Loan;
    transactions?: MonthlyTransactions;
    summary?: Summary;
    wongaDetails?: WongaDetails;

    constructor(data?: IMonthlyStatement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementDate = _data["statementDate"] ? new Date(_data["statementDate"].toString()) : undefined as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.openingBalance = _data["openingBalance"];
            this.currentBalance = _data["currentBalance"];
            this.closingBalance = _data["closingBalance"];
            this.customer = _data["customer"] ? CustomerDetails.fromJS(_data["customer"]) : undefined as any;
            this.address = _data["address"] ? AddressDetails.fromJS(_data["address"]) : undefined as any;
            this.loan = _data["loan"] ? Loan.fromJS(_data["loan"]) : undefined as any;
            this.transactions = _data["transactions"] ? MonthlyTransactions.fromJS(_data["transactions"]) : undefined as any;
            this.summary = _data["summary"] ? Summary.fromJS(_data["summary"]) : undefined as any;
            this.wongaDetails = _data["wongaDetails"] ? WongaDetails.fromJS(_data["wongaDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): MonthlyStatement {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyStatement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["openingBalance"] = this.openingBalance;
        data["currentBalance"] = this.currentBalance;
        data["closingBalance"] = this.closingBalance;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["loan"] = this.loan ? this.loan.toJSON() : undefined as any;
        data["transactions"] = this.transactions ? this.transactions.toJSON() : undefined as any;
        data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
        data["wongaDetails"] = this.wongaDetails ? this.wongaDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface IMonthlyStatement {
    statementDate?: Date;
    startDate?: Date;
    endDate?: Date;
    openingBalance?: number;
    currentBalance?: number;
    closingBalance?: number;
    customer?: CustomerDetails;
    address?: AddressDetails;
    loan?: Loan;
    transactions?: MonthlyTransactions;
    summary?: Summary;
    wongaDetails?: WongaDetails;
}

export class MonthlyTransaction implements IMonthlyTransaction {
    date?: Date;
    typeDescription?: string | undefined;
    amount?: number;
    amountType?: string | undefined;
    balance?: number;
    transactionCategory?: string | undefined;

    constructor(data?: IMonthlyTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.typeDescription = _data["typeDescription"];
            this.amount = _data["amount"];
            this.amountType = _data["amountType"];
            this.balance = _data["balance"];
            this.transactionCategory = _data["transactionCategory"];
        }
    }

    static fromJS(data: any): MonthlyTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["typeDescription"] = this.typeDescription;
        data["amount"] = this.amount;
        data["amountType"] = this.amountType;
        data["balance"] = this.balance;
        data["transactionCategory"] = this.transactionCategory;
        return data;
    }
}

export interface IMonthlyTransaction {
    date?: Date;
    typeDescription?: string | undefined;
    amount?: number;
    amountType?: string | undefined;
    balance?: number;
    transactionCategory?: string | undefined;
}

export class MonthlyTransactions implements IMonthlyTransactions {
    transactions?: MonthlyTransaction[] | undefined;

    constructor(data?: IMonthlyTransactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(MonthlyTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyTransactions {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyTransactions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMonthlyTransactions {
    transactions?: MonthlyTransaction[] | undefined;
}

export class OpenApplication implements IOpenApplication {
    loanId?: string;
    applicationId?: string;
    openLoanStatus?: OpenLoanStatus;

    constructor(data?: IOpenApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.applicationId = _data["applicationId"];
            this.openLoanStatus = _data["openLoanStatus"];
        }
    }

    static fromJS(data: any): OpenApplication {
        data = typeof data === 'object' ? data : {};
        let result = new OpenApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["applicationId"] = this.applicationId;
        data["openLoanStatus"] = this.openLoanStatus;
        return data;
    }
}

export interface IOpenApplication {
    loanId?: string;
    applicationId?: string;
    openLoanStatus?: OpenLoanStatus;
}

export class OpenLoanDetailsResponse implements IOpenLoanDetailsResponse {
    loanData?: LoanData;
    loanStateResponse?: GetLoanStateResponse;
    quotationData?: QuotationData;
    hasOpenLoan?: boolean;
    openLoanStatus?: OpenLoanStatus;
    isDne?: boolean;
    originalLoanAmount?: number;
    hasClosedLoan?: boolean;

    constructor(data?: IOpenLoanDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanData = _data["loanData"] ? LoanData.fromJS(_data["loanData"]) : undefined as any;
            this.loanStateResponse = _data["loanStateResponse"] ? GetLoanStateResponse.fromJS(_data["loanStateResponse"]) : undefined as any;
            this.quotationData = _data["quotationData"] ? QuotationData.fromJS(_data["quotationData"]) : undefined as any;
            this.hasOpenLoan = _data["hasOpenLoan"];
            this.openLoanStatus = _data["openLoanStatus"];
            this.isDne = _data["isDne"];
            this.originalLoanAmount = _data["originalLoanAmount"];
            this.hasClosedLoan = _data["hasClosedLoan"];
        }
    }

    static fromJS(data: any): OpenLoanDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OpenLoanDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanData"] = this.loanData ? this.loanData.toJSON() : undefined as any;
        data["loanStateResponse"] = this.loanStateResponse ? this.loanStateResponse.toJSON() : undefined as any;
        data["quotationData"] = this.quotationData ? this.quotationData.toJSON() : undefined as any;
        data["hasOpenLoan"] = this.hasOpenLoan;
        data["openLoanStatus"] = this.openLoanStatus;
        data["isDne"] = this.isDne;
        data["originalLoanAmount"] = this.originalLoanAmount;
        data["hasClosedLoan"] = this.hasClosedLoan;
        return data;
    }
}

export interface IOpenLoanDetailsResponse {
    loanData?: LoanData;
    loanStateResponse?: GetLoanStateResponse;
    quotationData?: QuotationData;
    hasOpenLoan?: boolean;
    openLoanStatus?: OpenLoanStatus;
    isDne?: boolean;
    originalLoanAmount?: number;
    hasClosedLoan?: boolean;
}

export enum OpenLoanStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class OzowPaymentStatusRequest implements IOzowPaymentStatusRequest {
    loanId?: string;
    status?: string | undefined;

    constructor(data?: IOzowPaymentStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OzowPaymentStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OzowPaymentStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["status"] = this.status;
        return data;
    }
}

export interface IOzowPaymentStatusRequest {
    loanId?: string;
    status?: string | undefined;
}

export class PaidUpLetter implements IPaidUpLetter {
    externalReferenceId?: string | undefined;
    name?: string | undefined;
    idNumber?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    closedOn?: Date;

    constructor(data?: IPaidUpLetter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalReferenceId = _data["externalReferenceId"];
            this.name = _data["name"];
            this.idNumber = _data["idNumber"];
            this.loanAmount = _data["loanAmount"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaidUpLetter {
        data = typeof data === 'object' ? data : {};
        let result = new PaidUpLetter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalReferenceId"] = this.externalReferenceId;
        data["name"] = this.name;
        data["idNumber"] = this.idNumber;
        data["loanAmount"] = this.loanAmount;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IPaidUpLetter {
    externalReferenceId?: string | undefined;
    name?: string | undefined;
    idNumber?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    closedOn?: Date;
}

export class PaidUpLetterHeader implements IPaidUpLetterHeader {
    loanId?: string;
    externalReferenceId?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    closedOn?: Date;
    term?: number;
    isIl?: boolean;
    customerDetailsExists?: boolean;

    constructor(data?: IPaidUpLetterHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.externalReferenceId = _data["externalReferenceId"];
            this.loanAmount = _data["loanAmount"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            this.term = _data["term"];
            this.isIl = _data["isIl"];
            this.customerDetailsExists = _data["customerDetailsExists"];
        }
    }

    static fromJS(data: any): PaidUpLetterHeader {
        data = typeof data === 'object' ? data : {};
        let result = new PaidUpLetterHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["externalReferenceId"] = this.externalReferenceId;
        data["loanAmount"] = this.loanAmount;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        data["term"] = this.term;
        data["isIl"] = this.isIl;
        data["customerDetailsExists"] = this.customerDetailsExists;
        return data;
    }
}

export interface IPaidUpLetterHeader {
    loanId?: string;
    externalReferenceId?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    closedOn?: Date;
    term?: number;
    isIl?: boolean;
    customerDetailsExists?: boolean;
}

export enum PaymentMethodEnums {
    Unspecified = "Unspecified",
    Card = "Card",
    Ozow = "Ozow",
    CapitecPay = "CapitecPay",
}

export class PaymentRedirectUrlResponse implements IPaymentRedirectUrlResponse {
    sessionUrl?: string | undefined;

    constructor(data?: IPaymentRedirectUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionUrl = _data["sessionUrl"];
        }
    }

    static fromJS(data: any): PaymentRedirectUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRedirectUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionUrl"] = this.sessionUrl;
        return data;
    }
}

export interface IPaymentRedirectUrlResponse {
    sessionUrl?: string | undefined;
}

export enum PaymentStatusEnums {
    Unspecified = "Unspecified",
    Requested = "Requested",
    Success = "Success",
    Failed = "Failed",
    Cancelled = "Cancelled",
}

export class PaymentStatusRequest implements IPaymentStatusRequest {
    loanId?: string;
    status?: PaymentStatusEnums;
    paymentMethod?: PaymentMethodEnums;

    constructor(data?: IPaymentStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
            this.status = _data["status"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): PaymentStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        data["status"] = this.status;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IPaymentStatusRequest {
    loanId?: string;
    status?: PaymentStatusEnums;
    paymentMethod?: PaymentMethodEnums;
}

export class Product implements IProduct {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    availability?: string | undefined;
    specificationJson?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.availability = _data["availability"];
            this.specificationJson = _data["specificationJson"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["availability"] = this.availability;
        data["specificationJson"] = this.specificationJson;
        return data;
    }
}

export interface IProduct {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    availability?: string | undefined;
    specificationJson?: string | undefined;
}

export class ProductConfig implements IProductConfig {
    limits?: Limits[] | undefined;
    sliderConfig?: SliderConfig[] | undefined;

    constructor(data?: IProductConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["limits"])) {
                this.limits = [] as any;
                for (let item of _data["limits"])
                    this.limits!.push(Limits.fromJS(item));
            }
            if (Array.isArray(_data["sliderConfig"])) {
                this.sliderConfig = [] as any;
                for (let item of _data["sliderConfig"])
                    this.sliderConfig!.push(SliderConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ProductConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.limits)) {
            data["limits"] = [];
            for (let item of this.limits)
                data["limits"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sliderConfig)) {
            data["sliderConfig"] = [];
            for (let item of this.sliderConfig)
                data["sliderConfig"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductConfig {
    limits?: Limits[] | undefined;
    sliderConfig?: SliderConfig[] | undefined;
}

export class ProductDescription implements IProductDescription {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    availability?: string | undefined;

    constructor(data?: IProductDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.availability = _data["availability"];
        }
    }

    static fromJS(data: any): ProductDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["availability"] = this.availability;
        return data;
    }
}

export interface IProductDescription {
    productId?: string;
    name?: string | undefined;
    description?: string | undefined;
    availability?: string | undefined;
}

export class QuotationData implements IQuotationData {
    applicationDate?: Date;
    initiationFee?: number;
    installmentAmount?: number;
    interestRateMonthly?: number;
    interestRateDaily?: number;
    productId?: string;
    quotationId?: string;
    promiseDate?: Date;
    serviceFee?: number;
    term?: number;
    totalRepayable?: number;
    loanAmount?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    termInDays?: number;
    salaryDay?: number;
    insuranceFee?: number;
    creditCostMultiple?: number;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefit?: DeathBenefitQuotationData;
    isConcurrentLoan?: boolean;

    constructor(data?: IQuotationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.initiationFee = _data["initiationFee"];
            this.installmentAmount = _data["installmentAmount"];
            this.interestRateMonthly = _data["interestRateMonthly"];
            this.interestRateDaily = _data["interestRateDaily"];
            this.productId = _data["productId"];
            this.quotationId = _data["quotationId"];
            this.promiseDate = _data["promiseDate"] ? new Date(_data["promiseDate"].toString()) : undefined as any;
            this.serviceFee = _data["serviceFee"];
            this.term = _data["term"];
            this.totalRepayable = _data["totalRepayable"];
            this.loanAmount = _data["loanAmount"];
            this.totalServiceFees = _data["totalServiceFees"];
            this.interestAmount = _data["interestAmount"];
            this.termInDays = _data["termInDays"];
            this.salaryDay = _data["salaryDay"];
            this.insuranceFee = _data["insuranceFee"];
            this.creditCostMultiple = _data["creditCostMultiple"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            if (Array.isArray(_data["collectionDates"])) {
                this.collectionDates = [] as any;
                for (let item of _data["collectionDates"])
                    this.collectionDates!.push(new Date(item));
            }
            this.deathBenefit = _data["deathBenefit"] ? DeathBenefitQuotationData.fromJS(_data["deathBenefit"]) : undefined as any;
            this.isConcurrentLoan = _data["isConcurrentLoan"];
        }
    }

    static fromJS(data: any): QuotationData {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["initiationFee"] = this.initiationFee;
        data["installmentAmount"] = this.installmentAmount;
        data["interestRateMonthly"] = this.interestRateMonthly;
        data["interestRateDaily"] = this.interestRateDaily;
        data["productId"] = this.productId;
        data["quotationId"] = this.quotationId;
        data["promiseDate"] = this.promiseDate ? this.promiseDate.toISOString() : undefined as any;
        data["serviceFee"] = this.serviceFee;
        data["term"] = this.term;
        data["totalRepayable"] = this.totalRepayable;
        data["loanAmount"] = this.loanAmount;
        data["totalServiceFees"] = this.totalServiceFees;
        data["interestAmount"] = this.interestAmount;
        data["termInDays"] = this.termInDays;
        data["salaryDay"] = this.salaryDay;
        data["insuranceFee"] = this.insuranceFee;
        data["creditCostMultiple"] = this.creditCostMultiple;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        if (Array.isArray(this.collectionDates)) {
            data["collectionDates"] = [];
            for (let item of this.collectionDates)
                data["collectionDates"].push(item.toISOString());
        }
        data["deathBenefit"] = this.deathBenefit ? this.deathBenefit.toJSON() : undefined as any;
        data["isConcurrentLoan"] = this.isConcurrentLoan;
        return data;
    }
}

export interface IQuotationData {
    applicationDate?: Date;
    initiationFee?: number;
    installmentAmount?: number;
    interestRateMonthly?: number;
    interestRateDaily?: number;
    productId?: string;
    quotationId?: string;
    promiseDate?: Date;
    serviceFee?: number;
    term?: number;
    totalRepayable?: number;
    loanAmount?: number;
    totalServiceFees?: number;
    interestAmount?: number;
    termInDays?: number;
    salaryDay?: number;
    insuranceFee?: number;
    creditCostMultiple?: number;
    validUntil?: Date;
    collectionDates?: Date[] | undefined;
    deathBenefit?: DeathBenefitQuotationData;
    isConcurrentLoan?: boolean;
}

export class RejectOfferRequest implements IRejectOfferRequest {
    loanId?: string;

    constructor(data?: IRejectOfferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): RejectOfferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectOfferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface IRejectOfferRequest {
    loanId?: string;
}

export class RejectOfferResponse implements IRejectOfferResponse {
    success?: boolean;

    constructor(data?: IRejectOfferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): RejectOfferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RejectOfferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IRejectOfferResponse {
    success?: boolean;
}

export class SaveApplicationRequest implements ISaveApplicationRequest {
    loanId?: string;

    constructor(data?: ISaveApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): SaveApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface ISaveApplicationRequest {
    loanId?: string;
}

export class SaveApplicationResponse implements ISaveApplicationResponse {

    constructor(data?: ISaveApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISaveApplicationResponse {
}

export class SessionUrlResponse implements ISessionUrlResponse {
    sessionUrl?: string | undefined;
    paymentRequestId?: string | undefined;

    constructor(data?: ISessionUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionUrl = _data["sessionUrl"];
            this.paymentRequestId = _data["paymentRequestId"];
        }
    }

    static fromJS(data: any): SessionUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SessionUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionUrl"] = this.sessionUrl;
        data["paymentRequestId"] = this.paymentRequestId;
        return data;
    }
}

export interface ISessionUrlResponse {
    sessionUrl?: string | undefined;
    paymentRequestId?: string | undefined;
}

export class SettlementDetails implements ISettlementDetails {
    settlementBalance?: number;
    createdOn?: Date;
    validTo?: Date;

    constructor(data?: ISettlementDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settlementBalance = _data["settlementBalance"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SettlementDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settlementBalance"] = this.settlementBalance;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface ISettlementDetails {
    settlementBalance?: number;
    createdOn?: Date;
    validTo?: Date;
}

export class SettlementLetterDetailsResponse implements ISettlementLetterDetailsResponse {
    accountNumber?: string | undefined;
    address?: Address;
    customer?: Customer;
    wongaDetails?: WongaDetails;
    status?: SettlementLetterResponseStatusEnum;
    settlementDetails?: SettlementDetails;

    constructor(data?: ISettlementLetterDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined as any;
            this.wongaDetails = _data["wongaDetails"] ? WongaDetails.fromJS(_data["wongaDetails"]) : undefined as any;
            this.status = _data["status"];
            this.settlementDetails = _data["settlementDetails"] ? SettlementDetails.fromJS(_data["settlementDetails"]) : undefined as any;
        }
    }

    static fromJS(data: any): SettlementLetterDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementLetterDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["wongaDetails"] = this.wongaDetails ? this.wongaDetails.toJSON() : undefined as any;
        data["status"] = this.status;
        data["settlementDetails"] = this.settlementDetails ? this.settlementDetails.toJSON() : undefined as any;
        return data;
    }
}

export interface ISettlementLetterDetailsResponse {
    accountNumber?: string | undefined;
    address?: Address;
    customer?: Customer;
    wongaDetails?: WongaDetails;
    status?: SettlementLetterResponseStatusEnum;
    settlementDetails?: SettlementDetails;
}

export enum SettlementLetterResponseStatusEnum {
    Unspecified = "Unspecified",
    Success = "Success",
    LoanNotExist = "LoanNotExist",
    LoanAccountNumberNotExist = "LoanAccountNumberNotExist",
    LoanNotInAnActiveState = "LoanNotInAnActiveState",
}

export class SignApplicationRequest implements ISignApplicationRequest {
    accountId?: string;
    loanId?: string;

    constructor(data?: ISignApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.loanId = _data["loanId"];
        }
    }

    static fromJS(data: any): SignApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["loanId"] = this.loanId;
        return data;
    }
}

export interface ISignApplicationRequest {
    accountId?: string;
    loanId?: string;
}

export class SignApplicationResponse implements ISignApplicationResponse {

    constructor(data?: ISignApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SignApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISignApplicationResponse {
}

export class SliderConfig implements ISliderConfig {
    productId?: string;
    termMax?: number;
    termMin?: number;
    amountMax?: number;
    amountMin?: number;
    termDefault?: number | undefined;

    constructor(data?: ISliderConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.termMax = _data["termMax"];
            this.termMin = _data["termMin"];
            this.amountMax = _data["amountMax"];
            this.amountMin = _data["amountMin"];
            this.termDefault = _data["termDefault"];
        }
    }

    static fromJS(data: any): SliderConfig {
        data = typeof data === 'object' ? data : {};
        let result = new SliderConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["termMax"] = this.termMax;
        data["termMin"] = this.termMin;
        data["amountMax"] = this.amountMax;
        data["amountMin"] = this.amountMin;
        data["termDefault"] = this.termDefault;
        return data;
    }
}

export interface ISliderConfig {
    productId?: string;
    termMax?: number;
    termMin?: number;
    amountMax?: number;
    amountMin?: number;
    termDefault?: number | undefined;
}

export class StartApplicationVerificationResult implements IStartApplicationVerificationResult {
    success?: boolean;
    missingBankDetails?: boolean;
    invalidProductId?: boolean;
    missingCustomerData?: boolean;
    missingContact?: boolean;
    missingEmployment?: boolean;
    missingAddress?: boolean;
    disbursementCoolingOff?: boolean;
    disbursementCoolOffDays?: number;

    constructor(data?: IStartApplicationVerificationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.missingBankDetails = _data["missingBankDetails"];
            this.invalidProductId = _data["invalidProductId"];
            this.missingCustomerData = _data["missingCustomerData"];
            this.missingContact = _data["missingContact"];
            this.missingEmployment = _data["missingEmployment"];
            this.missingAddress = _data["missingAddress"];
            this.disbursementCoolingOff = _data["disbursementCoolingOff"];
            this.disbursementCoolOffDays = _data["disbursementCoolOffDays"];
        }
    }

    static fromJS(data: any): StartApplicationVerificationResult {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplicationVerificationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["missingBankDetails"] = this.missingBankDetails;
        data["invalidProductId"] = this.invalidProductId;
        data["missingCustomerData"] = this.missingCustomerData;
        data["missingContact"] = this.missingContact;
        data["missingEmployment"] = this.missingEmployment;
        data["missingAddress"] = this.missingAddress;
        data["disbursementCoolingOff"] = this.disbursementCoolingOff;
        data["disbursementCoolOffDays"] = this.disbursementCoolOffDays;
        return data;
    }
}

export interface IStartApplicationVerificationResult {
    success?: boolean;
    missingBankDetails?: boolean;
    invalidProductId?: boolean;
    missingCustomerData?: boolean;
    missingContact?: boolean;
    missingEmployment?: boolean;
    missingAddress?: boolean;
    disbursementCoolingOff?: boolean;
    disbursementCoolOffDays?: number;
}

export class StatementData implements IStatementData {
    statementId?: string;
    statementEndDate?: Date;

    constructor(data?: IStatementData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statementId = _data["statementId"];
            this.statementEndDate = _data["statementEndDate"] ? new Date(_data["statementEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StatementData {
        data = typeof data === 'object' ? data : {};
        let result = new StatementData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementId"] = this.statementId;
        data["statementEndDate"] = this.statementEndDate ? this.statementEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IStatementData {
    statementId?: string;
    statementEndDate?: Date;
}

export class StatementHeader implements IStatementHeader {
    externalReferenceId?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    term?: number;
    isIl?: boolean;
    statementData?: StatementData[] | undefined;

    constructor(data?: IStatementHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalReferenceId = _data["externalReferenceId"];
            this.loanAmount = _data["loanAmount"];
            this.applicationDate = _data["applicationDate"] ? new Date(_data["applicationDate"].toString()) : undefined as any;
            this.term = _data["term"];
            this.isIl = _data["isIl"];
            if (Array.isArray(_data["statementData"])) {
                this.statementData = [] as any;
                for (let item of _data["statementData"])
                    this.statementData!.push(StatementData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementHeader {
        data = typeof data === 'object' ? data : {};
        let result = new StatementHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalReferenceId"] = this.externalReferenceId;
        data["loanAmount"] = this.loanAmount;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["term"] = this.term;
        data["isIl"] = this.isIl;
        if (Array.isArray(this.statementData)) {
            data["statementData"] = [];
            for (let item of this.statementData)
                data["statementData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatementHeader {
    externalReferenceId?: string | undefined;
    loanAmount?: number;
    applicationDate?: Date;
    term?: number;
    isIl?: boolean;
    statementData?: StatementData[] | undefined;
}

export class Summary implements ISummary {
    feesCharged?: number;
    interestCharged?: number;
    paymentsReceived?: number;
    thirtyDayArrearsAmount?: number;
    sixtyDayArrearsAmount?: number;
    ninetyDayArrearsAmount?: number;
    oneHundredAndEightyDayArrearsAmount?: number;
    totalArrearsAmount?: number;

    constructor(data?: ISummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feesCharged = _data["feesCharged"];
            this.interestCharged = _data["interestCharged"];
            this.paymentsReceived = _data["paymentsReceived"];
            this.thirtyDayArrearsAmount = _data["thirtyDayArrearsAmount"];
            this.sixtyDayArrearsAmount = _data["sixtyDayArrearsAmount"];
            this.ninetyDayArrearsAmount = _data["ninetyDayArrearsAmount"];
            this.oneHundredAndEightyDayArrearsAmount = _data["oneHundredAndEightyDayArrearsAmount"];
            this.totalArrearsAmount = _data["totalArrearsAmount"];
        }
    }

    static fromJS(data: any): Summary {
        data = typeof data === 'object' ? data : {};
        let result = new Summary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feesCharged"] = this.feesCharged;
        data["interestCharged"] = this.interestCharged;
        data["paymentsReceived"] = this.paymentsReceived;
        data["thirtyDayArrearsAmount"] = this.thirtyDayArrearsAmount;
        data["sixtyDayArrearsAmount"] = this.sixtyDayArrearsAmount;
        data["ninetyDayArrearsAmount"] = this.ninetyDayArrearsAmount;
        data["oneHundredAndEightyDayArrearsAmount"] = this.oneHundredAndEightyDayArrearsAmount;
        data["totalArrearsAmount"] = this.totalArrearsAmount;
        return data;
    }
}

export interface ISummary {
    feesCharged?: number;
    interestCharged?: number;
    paymentsReceived?: number;
    thirtyDayArrearsAmount?: number;
    sixtyDayArrearsAmount?: number;
    ninetyDayArrearsAmount?: number;
    oneHundredAndEightyDayArrearsAmount?: number;
    totalArrearsAmount?: number;
}

export class Transaction implements ITransaction {
    transactionAmount?: number | undefined;
    transactionDescription?: string | undefined;
    transactionDateTime?: Date | undefined;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionAmount = _data["transactionAmount"];
            this.transactionDescription = _data["transactionDescription"];
            this.transactionDateTime = _data["transactionDateTime"] ? new Date(_data["transactionDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionAmount"] = this.transactionAmount;
        data["transactionDescription"] = this.transactionDescription;
        data["transactionDateTime"] = this.transactionDateTime ? this.transactionDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ITransaction {
    transactionAmount?: number | undefined;
    transactionDescription?: string | undefined;
    transactionDateTime?: Date | undefined;
}

export enum TransactionTypeEnum {
    Unspecified = "Unspecified",
    Cashout = "Cashout",
    NextInstallment = "NextInstallment",
    FutureInstallment = "FutureInstallment",
}

export class Transactions implements ITransactions {
    transactionList?: Transaction[] | undefined;

    constructor(data?: ITransactions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionList"])) {
                this.transactionList = [] as any;
                for (let item of _data["transactionList"])
                    this.transactionList!.push(Transaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Transactions {
        data = typeof data === 'object' ? data : {};
        let result = new Transactions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionList)) {
            data["transactionList"] = [];
            for (let item of this.transactionList)
                data["transactionList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITransactions {
    transactionList?: Transaction[] | undefined;
}

export enum UnifiedLoanReason {
    Unspecified = "Unspecified",
    ApplicationNotApproved = "ApplicationNotApproved",
    FraudConcern = "FraudConcern",
    UserCancelled = "UserCancelled",
    ApplicationExpired = "ApplicationExpired",
    BankVerificationFailed = "BankVerificationFailed",
    ManualCancellation = "ManualCancellation",
    LoanClosed = "LoanClosed",
}

export class WaitApplicationResponse implements IWaitApplicationResponse {
    applicationAdvice?: ApplicationAdvice;
    applicationInfo?: ApplicationInfo;
    loanInfo?: LoanInfo;
    applicationStatus?: ApplicationStatus;
    mandateInfo?: MandateInfo;
    bankVerification?: BankVerification;
    avaInfo?: AvaInfo;
    success?: boolean;

    constructor(data?: IWaitApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationAdvice = _data["applicationAdvice"] ? ApplicationAdvice.fromJS(_data["applicationAdvice"]) : undefined as any;
            this.applicationInfo = _data["applicationInfo"] ? ApplicationInfo.fromJS(_data["applicationInfo"]) : undefined as any;
            this.loanInfo = _data["loanInfo"] ? LoanInfo.fromJS(_data["loanInfo"]) : undefined as any;
            this.applicationStatus = _data["applicationStatus"];
            this.mandateInfo = _data["mandateInfo"] ? MandateInfo.fromJS(_data["mandateInfo"]) : undefined as any;
            this.bankVerification = _data["bankVerification"] ? BankVerification.fromJS(_data["bankVerification"]) : undefined as any;
            this.avaInfo = _data["avaInfo"] ? AvaInfo.fromJS(_data["avaInfo"]) : undefined as any;
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): WaitApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WaitApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationAdvice"] = this.applicationAdvice ? this.applicationAdvice.toJSON() : undefined as any;
        data["applicationInfo"] = this.applicationInfo ? this.applicationInfo.toJSON() : undefined as any;
        data["loanInfo"] = this.loanInfo ? this.loanInfo.toJSON() : undefined as any;
        data["applicationStatus"] = this.applicationStatus;
        data["mandateInfo"] = this.mandateInfo ? this.mandateInfo.toJSON() : undefined as any;
        data["bankVerification"] = this.bankVerification ? this.bankVerification.toJSON() : undefined as any;
        data["avaInfo"] = this.avaInfo ? this.avaInfo.toJSON() : undefined as any;
        data["success"] = this.success;
        return data;
    }
}

export interface IWaitApplicationResponse {
    applicationAdvice?: ApplicationAdvice;
    applicationInfo?: ApplicationInfo;
    loanInfo?: LoanInfo;
    applicationStatus?: ApplicationStatus;
    mandateInfo?: MandateInfo;
    bankVerification?: BankVerification;
    avaInfo?: AvaInfo;
    success?: boolean;
}

export class WongaDetails implements IWongaDetails {
    bankName?: string | undefined;
    accountName?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    webUrl?: string | undefined;
    contactNumber?: string | undefined;
    contactEmail?: string | undefined;
    paymentEmail?: string | undefined;

    constructor(data?: IWongaDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.accountName = _data["accountName"];
            this.branchCode = _data["branchCode"];
            this.accountNumber = _data["accountNumber"];
            this.webUrl = _data["webUrl"];
            this.contactNumber = _data["contactNumber"];
            this.contactEmail = _data["contactEmail"];
            this.paymentEmail = _data["paymentEmail"];
        }
    }

    static fromJS(data: any): WongaDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WongaDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["accountName"] = this.accountName;
        data["branchCode"] = this.branchCode;
        data["accountNumber"] = this.accountNumber;
        data["webUrl"] = this.webUrl;
        data["contactNumber"] = this.contactNumber;
        data["contactEmail"] = this.contactEmail;
        data["paymentEmail"] = this.paymentEmail;
        return data;
    }
}

export interface IWongaDetails {
    bankName?: string | undefined;
    accountName?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    webUrl?: string | undefined;
    contactNumber?: string | undefined;
    contactEmail?: string | undefined;
    paymentEmail?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export class IConfig {
  private readonly logout: () => void;

  constructor(logout: () => void) {
    this.logout = logout;
  }

  onLogout = (): void => {
    this.logout();
  };

  getAuthorization = (): string | null => {
    const token = localStorage.getItem("token");
    return token ? `Bearer ${token}` : null;
  };
}